// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: Merriweather Sans, sans-serif;
    font-size: 14px;
    font-weight: 700;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: normal;
    color: #444;
    padding-top: 60px;
}


h1 {
    font-family:  Merriweather Sans, sans-serif;
    font-size: 0;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: center;
    color: #fff;
}

p {
    font-family: Merriweather Sans, sans-serif;
}

h2,h3,h4 {
    font-family: Merriweather Sans, sans-serif;
    color: #444;
}

input,button {
    font-family: Merriweather Sans, sans-serif;
}

img {
    max-width: 100%;
}

address {
    font-family: Merriweather Sans, sans-serif;
    font-size: 14px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: #2e3a59;
}

.d-flex.about-lenskart {
    margin-top: 30px;
}

.store-address address i {
    font-size: 18px;
    margin-right: 10px;
    margin-top: 3px;
}

.store-address address .locality-store i {
    margin-right: 8px;
    margin-left: -3px;
}

a.store-directions {
    display: flex;
    color: #2e3a59;
    margin-top: 18px;
}

.contact-info-list li .inventory-icon svg {
    width: 27px;
    fill: #c4161c;
}

a.store-directions i {
    width: 30px;
    margin: -3px 3px 0 -5px;
}

.speak-experts span {
    display: block;
    margin-bottom: 18px;
    font-size: 17px;
    margin-top: 0;
    text-align: center;
    font-family: Merriweather Sans, sans-serif;
}

#content.detail-search .speak-experts.store-info {
    padding: 20px 20px 18px;
}

.tab-content.custom-tab-box .locality-store {
    margin-top: 18px;
    margin-bottom: 18px;
}

.detail-search .speak-experts .call-details a {
    font-size: 13px;
}

.detail-search .store-address address .locality-store i {
    margin-right: 7px;
}

span.upper-address {
    display: flex;
    margin-left: -5px;
}

address a {
    color: #c4161c;
    text-decoration: underline;
}

address a:hover {
    text-decoration: none;
}

.list-view-sidebar::-webkit-scrollbar {
    width: 5px;
    position: relative;
    top: 30px;
}

.list-view-sidebar::-webkit-scrollbar-thumb {
    background: #a6a6a6;
    position: relative;
    top: 30px;
}

.list-view-sidebar::-webkit-scrollbar-thumb:hover {
    background: #c4161c;
}

.flash-message.top-flashmessage {
    margin: 0;
    margin-top: -6px;
    background: #fde3bc;
}

.time-slot.disabled.blockthis {
    pointer-events: all;
    cursor: pointer;
}

.tel {
    color: #2e3a59;
    text-decoration: none;
    display: inline-block;
    margin: 13px 0 3px;
}

.store-timing {
    display: block;
    margin-top: 10px;
}

.btn {
    border-radius: 4px;
    background-color: #c4161c;
    font-size: 14px;
    font-weight: 700;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: normal;
    text-align: center;
    color: #fff;
    text-transform: uppercase;
}

.btn:hover {
    background: #d76c70;
}

.form-control:focus,.btn:focus {
    box-shadow: none;
}

a {
    transition: .3s;
}

#header {
    border-bottom: solid 3px #e4e9f2;
    position: fixed;
    left: 0;
    width: 100%;
    top: 0;
    transition: .4s;
    background: #fff;
    z-index: 999;
}

#header.sticky {
    background-color: #f7f9fc;
    box-shadow: 0 3px 5px rgba(57,63,72,.3);
    border-bottom: solid 3px #c4161c;
}

#header ul li {
    font-family: Merriweather Sans, sans-serif;
    display: inline-block;
    color: #444;
    font-weight: 600;
    font-size: 15px;
    line-height: 29px;
}

#header ul li a {
    color: #444;
    padding: 5px 14px;
    transition: .4s;
}

#header ul.main-nav li a:hover {
    background: #c4161c;
    color: #fff;
}

#header ul.nav-flex-icons li {
    font-size: 20px;
}

#header ul.nav-flex-icons li a {
    padding: 0 10px;
}

#header ul.nav-flex-icons li a:hover {
    color: #1e8178;
}

#header ul.navbar-nav li.toll_free_number_national {
    font-size: 16px;
    font-weight: 400;
}

#header ul.navbar-nav li.toll_free_number_national i {
    font-style: normal;
}

#header ul.navbar-nav li.toll_free_number_national a {
    font-weight: 500;
}

#corona-notif a {
    display: inline-block;
    text-align: center;
    margin: 0 10px;
    text-decoration: none;
}

#corona-notif span.text-center {
    display: block;
    margin-top: 5px;
}

.navbar-brand {
    padding: 0;
}

.navbar-light {
    background: #dcdbd4;
    margin-bottom: 10px;
    padding: 0;
}

.upper-part {
    display: flex;
    padding: 4px 0;
}

.nav-flex-icons {
    padding-top: 12px;
}

#content h1 {
    text-align: center;
}

.flash-message {
    background: #c9edea;
    text-align: center;
    padding: 10px 0;
    margin: 20px 0;
}

.flash-message p {
    margin-bottom: 0;
    font-weight: 400;
}

.store-locator {
    margin-top: 30px;
}

.store-locator ul {
    display: block;
    border: none;
    margin: 3px 0;
}

.store-locator ul li {
    display: inline-block;
    font-size: 14px;
    font-family: Merriweather Sans, sans-serif;
    text-transform: uppercase;
    font-weight: 700;
}

.store-locator #tabsJustified li a {
    border: none;
    padding: 0 19px;
    border-radius: 5px;
}

.store-locator #tabsJustified li a.active {
    background: #c4161c;
    color: #fff;
}

.store-locator ul li a.nav-link {
    display: inline-block;
    border: none;
    border-bottom: 5px solid #8f9bb3;
    padding: 0;
    color: #444;
    line-height: 34px;
}

.map-view-stores ul li a.nav-link {
    border: 1px solid #8f9bb3;
    color: #8f9bb3;
    font-size: 11px;
    font-weight: 400;
}

.map-view-stores ul li a.nav-link i {
    margin-right: 10px;
}

.map-view-stores ul li:first-child a {
    border-radius: 4px 0 0 4px;
}

.map-view-stores ul li:last-child a {
    border-radius: 0 4px 4px 0;
    border-left: 1px solid transparent;
}

.map-view-stores ul li a.nav-link:hover {
    border: 1px solid #c4161c;
}

.map-view-stores ul li a.nav-link.active {
    border: 1px solid #c4161c;
    background-color: #c4161c;
    color: #fff;
}

.map-view-stores .nav-tabs {
    border-radius: 0;
    margin-bottom: 0;
    border: none;
}

.map-view-stores .nav-tabs li {
    margin-bottom: 0;
}

.store-locator ul li a.nav-link.active {
    border: none;
    color: #c4161c;
    border-bottom: 5px solid #1e8178;
    background: 0 0;
}

#tabsJustifiedContent {
    text-align: center;
}

#search-nearby input.form-control,.detail-search .storelocator-search input,.searchinv {
    width: 80%;
    font-size: 15px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    color: #8f9bb3;
    height: 48px;
    border-radius: 4px;
    border: solid 1px #e4e9f2;
    background-color: #f7f9fc;
    float: left;
    padding-right: 35px;
}

#search-nearby input.form-control:focus {
    background: rgba(21,110,110,.11);
}

#tabsJustifiedContent .btn {
    height: 48px;
    float: right;
    width: 100%;
}

#tabsJustifiedContent .form-inline {
    display: block;
}

.dropdown-menu.radio .dropdown-item {
    position: relative;
    overflow: hidden;
    cursor: pointer;
}

.dropdown-menu.radio input {
    visibility: hidden;
    position: absolute;
    left: -30px;
}

.dropdown-menu.radio i {
    font-weight: 400;
    font-style: normal;
    display: block;
}

.dropdown-menu.radio input {
    visibility: hidden;
    position: absolute;
    left: -30px;
}

.dropdown-menu.radio i {
    font-weight: 400;
    font-style: normal;
    display: block;
}

.dropdown-item.active {
    background-color: #555;
    color: #fff;
}

main#content {
    margin-top: 30px;
}

.mobile-view {
    transition: .4s;
    width: 0;
    padding: 0;
    overflow: hidden;
    margin: 0;
}

.navbar-fixed-top .mobile-view {
    width: 214px;
}

.main-nav {
    transition: .4s;
}

.navbar .row {
    width: 100%;
}

.navbar .nav-flex-icons {
    position: absolute;
    top: 0;
    right: -15px;
    opacity: 0;
    transition: .4s;
}

.navbar-fixed-top.navbar .nav-flex-icons {
    opacity: 1;
}

.advanced-search-main {
    width: 100%;
}

#advanced-search .dropdown {
    display: flex;
    margin: 0 0 10px;
    width: 100%;
}

.dropdown-menu {
    width: 100%;
}

#advanced-search .dropdown .btn {
    width: 100%;
    margin-left: 0!important;
}

#tabsJustifiedContent .dropdown .dropdown-toggle {
    font-size: 15px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    color: #8f9bb3;
    height: 40px;
    border-radius: 4px;
    border: solid 1px #e4e9f2;
    background-color: #f7f9fc;
    width: 100%;
}

#tabsJustifiedContent .dropdown .dropdown-toggle ins {
    text-decoration: none;
    float: left;
    text-transform: none;
}

#search-switch-tab .btn {
    margin-top: 20px!important;
}

#search-switch-tab input {
    height: 48px;
}

#tabsJustifiedContent .dropdown-toggle::after {
    position: absolute;
    right: 15px;
    top: 23px;
}

#advanced-search .dropdown.show .dropdown-toggle::after {
    border-top: 0;
    border-right: .3em solid transparent;
    border-bottom: .3em solid;
    border-left: .3em solid transparent;
}

.dropdown-item.active {
    background: #1e8178;
}

.map-view-stores h2 {
    font-size: 14px;
    font-weight: 700;
    font-stretch: normal;
    font-style: normal;
    line-height: 28px;
    letter-spacing: normal;
    color: #2e3a59;
    margin: 0;
    text-transform: uppercase;
}

.map-view-stores {
    display: flex;
    border-radius: 4px;
    background-color: #edf1f7;
    margin: 25px 0 0;
    padding: 10px 15px;
}

.detail-search .storelocator-search input {
    padding-left: 35px;
    border: 1px solid #156e6e;
    color: #156e6e;
    font-weight: 700;
    width: 100%;
}

#content.detail-search h1 {
    text-align: left;
    font-size: 26px;
    margin-bottom: 5px;
}

#content.detail-search .list-view-sidebar {
    height: auto;
    overflow: visible;
    margin-top: 0;
    margin-bottom: 0;
    position: relative;
}

#content.detail-search #list-view {
    background: 0 0;
}

#content.detail-search .store-info {
    background: #edf1f7;
    border-radius: 5px;
    padding: 0;
}

#content.detail-search .nearby-stores-content .store-info {
    background: 0 0;
    padding: 0;
    width: 25%;
    box-shadow: none;
}

.detail-search .store-address {
    padding: 10px 15px 15px;
}

#content.detail-search .nearby-stores-content .store-info .store-address {
    padding: 15px 10px;
    margin: 0 5px;
    display: block;
    border: 1px solid #c4161c;
    color: #c4161c;
    border-radius: 5px;
}

#content.detail-search .nearby-stores-content .store-info .store-address:hover {
    text-decoration: none;
    background: #c4161c;
    color: #fff;
}

#content.detail-search .nearby-stores-content .store-info .store-address span {
    display: block;
    margin-bottom: 10px;
    font-size: 15px;
}

#content.detail-search .nearby-stores-content .store-info .store-address span a {
    color: #444;
    text-decoration: underline;
}

#content.detail-search .nearby-stores-content .store-info .store-address span a:hover {
    text-decoration: none;
}

.store-tags {
    margin-top: 20px;
}

.store-tags+.store-tags {
    margin-top: 0;
}

.about-lenskart h4 {
    text-align: left;
}

.detail-search .storelocator-search input::placeholder {
    color: #156e6e;
}

.detail-search .store-inventory.storelocator-search input::placeholder {
    color: #8f9bb3;
}

.search-inventory-page .glassimg {
    min-height: 115px;
    padding-top: 0;
    padding-bottom: 10px;
}

.filter-box {
    display: block;
    position: relative;
    padding-left: 23px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 14px;
    -webkit-user-select: none;
    user-select: none;
    font-weight: 400;
}

.filter-box input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
}

.checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 16px;
    width: 16px;
    background-color: #44444478;
}

.filter-container:last-child {
    border: none;
}

.filter-search {
    overflow: hidden;
    padding-bottom: 20px;
}

.search-box-inventroy {
    float: left;
    display: flex;
}

.sort-inventroy {
    float: right;
    text-align: right;
}

.sort-inventroy select {
    -webkit-appearance: none;
    background: #f5f5f5;
    padding: 10px 15px;
    border: none;
    border-radius: 0;
    cursor: pointer;
    display: inline-block;
    outline: none;
    margin: 0 0 0 9px;
}

.select {
    position: relative;
}

.select-arrow {
    position: absolute;
    top: 16px;
    right: 15px;
    width: 0;
    height: 0;
    pointer-events: none;
    border-style: solid;
    border-width: 8px 5px 0;
    border-color: #7b7b7b transparent transparent transparent;
}

.search-inventory-page .popular-product {
    margin-top: 0;
}

.filter-box:hover input~.checkmark {
    background-color: #ccc;
}

.filter-box input:checked~.checkmark {
    background-color: #156e6e;
}

.checkmark:after {
    content: "";
    position: absolute;
    display: none;
}

.filter-box input:checked~.checkmark:after {
    display: block;
}

a.canvasjs-chart-credit {
    display: none;
}

.chart-graph:before {
    content: "";
    height: 10px;
    background: #fff;
    position: absolute;
    left: 0;
    width: 63px;
    z-index: 9;
    bottom: 2px;
}

.chart-graph {
    position: relative;
    margin-top: 32px!important;
}

.graphflexslider {
    position: relative;
    padding: 10px 0;
}

.contact-info-list {
    list-style: none;
    padding: 0 0 15px;
    position: absolute;
    right: 10px;
    top: 0;
}

.contact-info-list li {
    text-align: center;
}

.contact-info-list li i {
    width: 40px;
    line-height: 40px;
    border-radius: 50%;
    border: 1px solid #c4161c;
    display: none;
    text-align: center;
    font-size: 16px;
    height: 40px;
    margin: 0 auto 7px;
}

.custom-tab-box .store-address {
    position: relative;
}

.custom-tab-box .store-address address {
    max-width: 75%;
    padding-top: 10px;
    margin-bottom: 0;
}

.contact-info-list li a {
    background: #c4161c;
    color: #fff;
    border-radius: 5px;
    line-height: 30px;
    padding: 0 5px;
    margin-top: 20px;
    display: inline-block;
    width: 98px;
}

.catalog-banner {
    margin-bottom: 7px;
}

.contact-info-list li a:focus,.contact-info-list li a:hover {
    outline: none;
    text-decoration: none;
    color: #f26638;
}

.contact-info-list li a:hover i {
    border: 1px solid #f26638;
}

.contact-info-list li a:hover .inventory-icon svg {
    fill: #f26638;
}

.contact-info-list li small {
    display: block;
    text-align: center;
    font-size: 11px;
    text-transform: uppercase;
    font-family: Merriweather Sans, sans-serif;
}

.contact-info-list li svg {
    height: 33px;
    margin-top: -4px;
}

.mobile-tab-view .nav-tabs::-webkit-scrollbar {
    width: 10px;
    border-radius: 5px;
}

.mobile-tab-view .nav-tabs::-webkit-scrollbar-track {
    background: #495057;
    border-radius: 5px;
}

.mobile-tab-view .nav-tabs::-webkit-scrollbar-thumb {
    background: #c4161c;
    border-radius: 5px;
}

.filter-box .checkmark:after {
    left: 5px;
    top: 1px;
    width: 6px;
    height: 10px;
    border: solid #fff;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    content: "";
    position: absolute;
}

.filter-container h3 {
    font-size: 14px;
    margin-bottom: 15px;
    text-transform: uppercase;
    font-weight: 700;
}

.filter-container {
    border-bottom: 1px solid rgb(0,0,0,.09);
    padding: 15px 0;
}

.search-inventory-page .product-slider .glassbox:hover {
    box-shadow: 0 3px 16px 0 rgba(0,0,0,.11);
}

.grey-box {
    padding: 10px;
}

.grey-box h2,.review h2,.store-inventory h2 {
    color: #2e3a59;
    font-size: 15px;
    font-weight: 700;
    margin-bottom: 15px;
}

.detail-search .store-inventory.storelocator-search input {
    padding-left: 10px;
    padding-right: 35px;
    color: #8f9bb3;
    font-size: 15px;
    font-weight: 400;
    border: 1px solid #e4e9f2;
}

.grey-box i {
    margin-right: 5px;
}

.payment ul {
    list-style: none;
    padding: 0 0 0 4px;
    margin-bottom: 0;
}

.payment ul li {
    display: inline-block;
    width: 48%;
    margin-bottom: 15px;
    color: #2e3a59;
    font-size: 14px;
    font-weight: 400;
}

.payment ul li i {
    color: #c4161c;
}

.timing {
    font-size: 13px;
    color: #2e3a59;
}

.timing span {
    font-weight: 400;
}

.store-detail-img img {
    height: 220px;
    object-fit: cover;
    width: 100%;
}

.popular-product {
    margin-top: 20px;
    min-height: 500px;
    position: relative;
}

.popular-product h3 {
    font-size: 15px;
    font-weight: 700;
}

.nearby-stores-content {
    text-align: center;
}

.nearby-stores h2 {
    margin-top: 30px;
    border-radius: 5px;
    background: #edf1f7;
    padding: 14px 0;
    font-size: 24px;
    font-weight: 700;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.14;
    letter-spacing: normal;
    text-align: center;
    color: #2e3a59;
    text-transform: uppercase;
}

.nearby-stores-content ul {
    padding: 0;
    list-style: none;
    display: flex;
}

.nearby-store-inner {
    display: none;
}

.browse-online-cat {
    margin-top: 30px;
    font-size: 20px;
    font-family: Merriweather Sans, sans-serif;
    margin-bottom: 15px;
}

section.display-grid {
    display: grid;
    grid-template-columns: repeat(2,1fr);
    grid-gap: 15px;
    margin-top: 15px;
}

section.display-grid a {
    box-shadow: 0 1px 5px #ddd;
    background: #fff;
    display: block;
}

.nearby-stores-content ul li {
    margin-right: 30px;
    position: relative;
}

.nearby-stores-content ul li:last-child {
    margin-right: 0;
}

.nearby-stores-content ul li img {
    border-radius: 5px;
    height: 190px;
    object-fit: cover;
    width: 270px;
}

.store-description {
    position: relative;
}

.viewallreview {
    text-align: right;
}

.viewallreview a {
    margin-top: 0;
}

.store-description {
    border-radius: 8px;
    background-blend-mode: multiply;
    background-image: linear-gradient( to bottom,rgba(0,0,0,0) 3%,rgb(16,20,38) );
    position: absolute;
    height: 100%;
    left: 0;
    top: 0;
    width: 100%;
    content: "";
}

.store-description:hover {
    background-image: linear-gradient( to bottom,rgba(0,0,0,0) -25%,rgb(16,20,38) );
}

.store-description span {
    font-size: 14px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    position: absolute;
    color: #fff;
    bottom: 6px;
    left: 15px;
    right: 15px;
    text-align: left;
    padding-right: 30px;
}

.store-description span i {
    position: absolute;
    right: 0;
    top: 21%;
}

.open-now {
    background: #f7ca02;
    border-radius: 2px;
    font-size: 11px;
    padding: 0 10px 2px;
    display: inline-block;
    color: #fff;
    line-height: normal;
    margin-left: 10px;
}

#map-content-view {
    position: relative;
}

.view-map {
    float: right;
}

#list-view {
    background: #edf1f7;
    min-height: 640px;
}

.list-view-sidebar {
    margin-top: 20px;
    margin-bottom: 20px;
    height: 600px;
    overflow-y: auto;
}

.store-banner {
    position: relative;
}

.store-info {
    margin-bottom: 15px;
    box-shadow: 2px 2px 11px 0 #ccc;
    border-radius: 5px;
    padding-top: 1px;
    background: #fff;
}

.rj-offer-desk {
    margin-top: 30px;
}

.store-banner span {
    position: absolute;
    bottom: 10px;
    color: #fff;
    font-size: 12px;
    font-family: Merriweather Sans, sans-serif;
    font-weight: 700;
    left: 15px;
}

.nearby-stores-content .row {
    margin: 0;
}

.store-img {
    position: relative;
    background: #fff;
    padding: 11px 0 28px;
    border-radius: 5px 5px 0 0;
    margin-bottom: 5px;
    border-bottom: 1px solid #c4161c;
}

.store-img a {
    display: block;
    position: relative;
}

.book-appointment {
    font-size: 12px;
    letter-spacing: .5px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: 40px;
    text-align: center;
    color: #fff;
    display: block;
    background: #f26522;
    text-transform: uppercase;
    margin-bottom: 15px;
    border-radius: 5px;
    margin-top: 10px;
    text-decoration: none;
}

.book-appointment:hover {
    background: #444;
    color: #fff;
    text-decoration: none;
}

.search-nearby-location {
    padding: 0 15px;
}

.call-details a {
    font-size: 11px;
    color: #fff;
    line-height: 40px;
    display: inline-block;
    border-radius: 5px;
    padding: 0 3%;
    width: 48%;
    text-transform: uppercase;
    text-align: center;
    margin: 0;
    text-decoration: none;
    background: #c4161c;
    font-weight: 400;
    letter-spacing: .5px;
}

.call-details a:hover {
    background: #444;
}

a.redefining-width {
    width: 49%!important;
}

.detail-search .call-details a {
    width: 47%;
    display: inline-block;
    padding: 0;
}

.store-img img {
    height: auto;
    object-fit: cover;
    width: 232px;
    padding: 0 38px 0 25px;
    margin: 0 auto;
    display: block;
}

.store-details {
    float: right;
}

.store-img a:before {
    position: absolute;
    height: 100%;
    width: 100%;
    content: "";
    top: 0;
    left: 0;
}

.store-img a:hover {
    text-decoration: none;
}

.store-address {
    padding: 10px 15px 1px;
}

#footer {
    background: #505050;
    color: #fff;
    padding: 18px 0 5px;
    color: #ccc;
    overflow: hidden;
    font-size: 13px;
    font-family: Merriweather Sans, sans-serif;
    font-weight: 300;
}

#footer a,#footer h4 {
    color: #fff;
    font-family: Merriweather Sans, sans-serif;
}

#footer h4 {
    font-size: 16px;
}

#footer a:hover {
    color: #1e8178;
}

.store-list {
    padding-bottom: 20px;
}

.footer-bottom {
    padding-top: 10px;
    float: left;
    width: 100%;
    border-top: 1px solid #fff;
}

#footer .copyright {
    text-transform: capitalize;
    padding: 5px 0;
    color: #fff;
    font-size: 14px;
    font-family: Merriweather Sans, sans-serif;
    font-weight: 600;
    margin: 0;
}

.detail-search .book-appointment-button a {
    background: 0 0;
    color: #2e3a59;
    font-family: Merriweather Sans, sans-serif;
    font-size: 14px;
    width: auto;
    margin: 0 0 0 9px;
    text-transform: none;
}

.modal.and.carousel {
    position: absolute;
}

.mobile-view {
    display: none;
}
/* 
.carousel-control {
    top: 45%;
    width: 5%;
    background-image: none;
}

.carousel-control.left,.carousel-control.right {
    background-image: none;
}

.carousel-control.left {
    margin-left: 25px;
}

.carousel-control.right {
    margin-right: 25px;
}

.carousel.slide {
    box-shadow: none;
} */

.store-inventory {
    margin-top: 30px;
}

.nearby-stores {
    margin-bottom: 25px;
    margin-top: 30px;
}

address strong {
    padding-left: 5px;
}

.store-name span i {
    float: right;
    margin-top: 2px;
}

.detail-search .graphflexslider .flex-direction-nav .flex-prev {
    left: auto;
    top: 23px;
    right: 19px;
    height: 24px;
    width: 18px;
}

.detail-search .graphflexslider .flex-direction-nav a:before {
    font-size: 22px;
}

.detail-search .flex-direction-nav .flex-prev:before {
    content: "\\f053";
}

.detail-search .graphflexslider .flex-direction-nav .flex-next {
    top: 23px;
    height: 24px;
    right: 0;
    width: 18px;
}

#day {
    position: absolute;
    z-index: 9;
    font-family: Merriweather Sans, sans-serif;
}

.graphflexslider {
    position: relative;
    padding: 10px 0;
}

.detail-search .flex-direction-nav .flex-next {
    right: 10px;
    opacity: 1;
    z-index: 1;
}

.detail-search .flex-direction-nav a.flex-next:before {
    content: "\\f054";
}

.detail-search .graphflexslider .flex-direction-nav a:before {
    font-size: 22px;
}

.detail-search .flex-direction-nav a:before {
    font-family: FontAwesome;
    color: #c4161c;
}

.detail-search .flex-direction-nav a:before {
    font-family: FontAwesome;
    color: #c4161c;
}

.locality-store {
    display: inline-block;
    margin-top: 13px;
    margin-bottom: 5px;
}

.detail-search .locality-store {
    display: flex;
}

.flash-message p i.flash-message-byk-icon {
    display: inline-block;
    width: 52px;
    height: 40px;
    margin-right: 5px;
    vertical-align: middle;
}

.flash-message p a {
    text-decoration: underline;
    color: red;
}

.flash-message p a:hover {
    text-decoration: none;
}

#mapOnSearch {
    height: 100%;
    width: 100%;
}

.detail-search .lenskart-gallery-slider {
    overflow: hidden;
    min-height: 500px;
    position: relative;
}

.inventory-loading {
    position: relative;
}

a.browse-inventory.redefining-width.full-on-desktop.hideondesktop {
    display: none;
}

a.book-appointment.makeithideonscrolll.browse-inventory.redefining-width {
    width: 100%!important;
    font-size: 11px;
}

.loading:before,.inventory-loading:before {
    display: block;
    content: "Loading Store Images";
    margin: auto;
    text-align: center;
    color: #505050;
    font-size: 18px;
    font-family: Merriweather Sans, sans-serif;
    text-transform: uppercase;
    position: absolute;
    left: 0;
    padding-top: 50px;
    top: 0;
    right: 0;
    border: 1px solid #eee;
    bottom: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
}

#map-content-view.loading:before {
    content: "";
    border: none;
}

span.queue {
    font-size: 12px;
    text-transform: initial;
}

#map-content-view .location.loading:before {
    content: "";
    border: none;
}

.product-slider {
    position: relative;
    min-height: 500px;
}

.inventory-loading:before {
    content: "Loading Inventory Images";
    top: 50px;
}

.detail-search .lenskart-gallery-slider ul li img {
    height: 360px;
    object-fit: cover;
    border-radius: 5px;
}

.detail-search .flexslider {
    margin: 0 0 20px;
}

.detail-search #slider.flexslider {
    border: 1px solid #eee;
}

.detail-search #carousel,.detail-search #carousel_1 {
    border: 10px solid #edf1f7;
    border-radius: 5px;
    background: #edf1f7;
}

.detail-search #carousel img,.detail-search #carousel_1 img {
    width: 100%;
    margin: 0;
    height: 180px;
    object-fit: cover;
    border-radius: 0;
}

.detail-search .flex-direction-nav .flex-next {
    right: 10px;
    opacity: 1;
    z-index: 1;
}

div#book {
    z-index: 99999;
}

.detail-search .flex-direction-nav a.flex-next:before {
    content: "\\f054";
}

#listingTable .flex-direction-nav a.flex-next:before,.searchResult .flex-direction-nav .flex-next:before {
    content: "\\f054";
}

#listingTable .flex-direction-nav a.flex-prev:before {
    content: "\\f053";
}

#listingTable .flex-direction-nav a.flex-next,.searchResult .flex-direction-nav .flex-next {
    right: -15px;
    opacity: 1;
}

.searchResult .flex-direction-nav .flex-next,.searchResult .flexslider:hover .flex-direction-nav .flex-next {
    right: 10px;
    opacity: 1;
}

.searchResult .flexslider:hover .flex-direction-nav .flex-prev {
    left: 10px;
}

.searchResult .flex-direction-nav .flex-prev {
    left: 10px;
    opacity: 1;
}

#listingTable .flex-direction-nav a.flex-prev {
    left: -15px;
    opacity: 1;
}

#google-reviews h2 a {
    float: right;
    width: auto;
    margin: 0;
    background: #ccc;
    padding: 5px 10px;
    font-size: 13px;
    border-radius: 4px;
}

#listingTable .flex-direction-nav a:before {
    font-family: FontAwesome;
    color: #c4161c;
}

div#carouselnew {
    margin: 0 auto;
    max-width: 560px;
}

.detail-search .flex-direction-nav a:before,.searchResult .flex-direction-nav a:before {
    font-family: FontAwesome;
    color: #c4161c;
}

#image_store_carousel li {
    border: 1px solid #ccc;
    cursor: pointer;
}

#image_store_carousel li.flex-active-slide {
    border: 1px solid #c4161c;
}

div#slidernew {
    margin: 0 0 30px;
}

.detail-search .flex-direction-nav .flex-prev:before,.searchResult .flex-direction-nav .flex-prev:before {
    content: "\\f053";
}

.detail-search .flex-direction-nav .flex-prev {
    left: 10px;
    opacity: 1;
    z-index: 1;
}

.detail-search #carousel .slides li,.detail-search #carousel_1 .slides li {
    position: relative;
    cursor: pointer;
}

.flexslider:hover .flex-direction-nav .flex-prev {
    opacity: .9;
    left: -15px;
}

.flexslider:hover .flex-direction-nav .flex-next {
    opacity: .9;
    right: -15px;
}

.searchResult-product .product-data p {
    font-size: 12px;
    text-transform: uppercase;
    padding: 0 10px;
}

.flexslider .slides>li {
    border: 1px solid #eee;
}

.searchResult-product .searchbtn .btn {
    margin: 20px 0 0!important;
    padding: 7px;
    font-size: 10px;
}

.searchResult.searchResult-product .container {
    margin-left: 10%;
    margin-right: 10%;
    width: 80%;
}

.searchResult .flexslider {
    margin: 0;
    border: none;
}

.searchResult-product .product-data {
    padding: 25px 0 12px;
}

.searchResult-product .product-image {
    padding-top: 10px;
    height: 75px;
    display: table-cell;
    text-align: center;
    vertical-align: middle;
    padding: 0 15px;
}

.searchResult.searchResult-product {
    border: none;
    padding: 0;
    margin: 0 0 -25px;
}

.detail-search #carousel .slides li:before {
    position: absolute;
    top: 0;
    left: 0;
    right: 15px;
    bottom: 0;
    text-align: center;
    z-index: 9;
    background: rgba(0,0,0,.4);
    content: "";
    width: 100%;
    z-index: 0;
    color: #fff;
}

.detail-search #carousel .slides li.flex-active-slide:before {
    display: none;
}

.detail-search #carousel .slides li:hover:before {
    display: block;
}

.store-detail-info h2 {
    display: none;
}

.input-wrapper {
    position: relative;
}

.clear {
    border: 1px solid transparent;
    background-color: transparent;
    display: inline-block;
    vertical-align: middle;
    outline: 0;
    cursor: pointer;
    float: left;
    margin: 14px 0 0 -28px;
    cursor: pointer;
}

.clear:after {
    content: "X";
    display: block;
    width: 20px;
    height: 20px;
    background-color: #4bb3a0;
    z-index: 1;
    font-family: Merriweather Sans, sans-serif;
    margin: auto;
    padding: 2px;
    border-radius: 50%;
    text-align: center;
    color: #fff;
    font-weight: 400;
    font-size: 15px;
    cursor: pointer;
}

#pac-input:not(:valid)~.clear {
    display: none;
}

#pac-input-for-search:not(:valid)~.clear {
    display: none;
}

#pac-input-for-search {
    height: 48px;
}

#pac-input:valid~.gps-location {
    display: none;
}

#mapFull {
    height: 100%;
    width: 100%;
}

#storetitle span {
    display: block;
    margin-bottom: 10px;
    font-size: 14px;
    color: #333;
    font-family: Merriweather Sans, sans-serif;
}

#storetitle {
    width: 250px;
}

#storetitle span:first-child {
    padding: 10px;
    background: #f7f7f7;
    margin-top: 10px;
    font-size: 15px;
    color: #373737;
    font-weight: 600;
}

#storetitle .store-call-detail span:first-child {
    background: 0 0;
    padding: 0;
}

#storetitle .store-call-detail span:first-child a {
    float: right;
    background: #ed1b24;
    padding: 3px 15px;
    color: #fff;
    margin-top: -3px;
    font-weight: 400;
}

#storetitle span a:hover,#storetitle .store-call-detail span:first-child a:hover {
    text-decoration: none;
    background: #444;
}

#search-nearby-tab p {
    text-align: left;
}

.map-store-details a {
    display: inline-flex;
    background: #04428f;
    font-size: 13px;
    text-transform: uppercase;
    padding: 0;
    width: 120px;
    text-align: center;
    height: 26px;
    align-items: center;
    justify-content: center;
    margin-left: 1px;
    color: #fff;
}

.map-store-details a:last-child {
    background: #1e8178;
    color: #fff;
    float: right;
}

#storetitle span.map-store-details {
    margin-bottom: 0;
}

#mapFullScreen {
    height: 750px;
}

.thischeck {
    background: #f36523;
}

.product-slider .glassbox {
    border: #ebebeb solid 1px;
    padding: 10px;
    margin-bottom: 15px;
    border-radius: 5px;
    cursor: pointer;
}

.product-slider .glassbox span {
    font-weight: 400;
    display: block;
    line-height: normal;
}

.thankyou img {
    max-width: 100px;
}

.thankyou .inner-wrapper {
    border: 2px solid #000;
    border-radius: 3px;
    max-width: 480px;
    margin: 0 auto;
    padding: 40px 40px 0;
}

p.success-msg {
    font-size: 22px;
    color: #505050;
    text-transform: uppercase;
    text-align: center;
    font-family: futurabt-book;
}

.thankyou span {
    display: block;
}

.modal-content .modal-body.thankyou {
    padding: 3rem 4rem;
    text-align: center;
}

#successModal button.btn-close {
    background: #000;
    color: #fff;
    width: 100%;
    border: 0;
    max-width: 200px;
    padding: 10px;
    position: relative;
    top: 20px;
    font-size: 15px;
    text-transform: uppercase;
    font-family: Merriweather Sans, sans-serif;
    cursor: pointer;
}

.cm-details p.address {
    font-size: 16px;
    color: #505050;
    font-family: Merriweather Sans, sans-serif;
}

.cm-details p.time-slot-book {
    font-family: Merriweather Sans, sans-serif;;
    font-size: 22px;
    color: #505050;
    line-height: normal;
    margin-bottom: 25px!important;
}

.site-map {
    padding: 0;
}

.site-map h3 {
    font-size: 24px;
    font-weight: 500;
}

.site-map h4 {
    font-size: 20px;
}

.site-map li.site-map-city {
    list-style: disc;
    padding: 25px 10px 5px 5px;
    margin-left: 29px;
}

.site-map li.site-map-state {
    list-style: none;
    padding: 0 0 5px 0;
    border-bottom: 2px solid #eee;
}

.site-map li.site-map-locality {
    list-style: circle;
    margin: 0 10px 6px 43px;
}

.site-map li.site-map-locality a {
    color: #c4161c;
}

.site-map-head {
    margin: 50px 0;
}

a.browse-inventory {
    font-size: 12px;
    color: #fff;
    line-height: 40px;
    display: inline-block;
    border-radius: 5px;
    width: 100%;
    text-transform: uppercase;
    text-align: center;
    margin: 8px 0 0;
    text-decoration: none;
    background: #f26638;
    font-weight: 400;
    letter-spacing: .5px;
    padding: 0% 3%;
    display: none;
}

.rj-offer-desk.showthis.home {
    display: none;
}

.rj-offer-desk.showthis {
    display: none;
}

img.img-responsive.small-banner {
    height: 10em;
    width: 100%;
    padding-bottom: 15px;
    padding-left: 15px;
    padding-right: 15px;
    display: none;
}

a.tel.b {
    width: 100%;
}

.call-details.review {
    padding-bottom: 15px;
}

a.tel-mobile {
    float: right;
    margin: 8px 0 0;
}

button.close {
    z-index: 1;
    position: relative;
}

div.searchbox.inventory {
    position: relative;
}

span.search-icon-mobile {
    float: right;
    margin: 14px 23px 0 0;
}

#search-nearby input.form-control.searchinv,.detail-search .storelocator-search input {
    height: 30px;
    width: 430px;
}

button#searchinvbtn img {
    height: 15px;
    width: 15px;
    cursor: pointer;
}

.searchResult {
    margin: 0 15px 30px;
    border: 1px solid rgb(235,229,229,.6);
    padding: 20px;
    border-radius: 5px;
}

.product-data p {
    font-size: 24px;
    line-height: normal;
}

.searchbtn .btn {
    margin: 20px 0 0!important;
    padding: 10px 20px;
    font-size: .8em;
}

.searchResult .product-price {
    color: #4bb3a0;
}

button#searchinvbtn {
    position: relative;
    right: 10px;
    border-radius: 0 4px 4px 0;
}

#appendInventorySearch.loading:before {
    content: "";
}

#footer .nav-flex-icons li {
    display: inline-block;
    padding: 0 8px;
}

#footer .nav-flex-icons {
    text-align: center;
}

#appendInventorySearch button.book-appointment.static-show.btn.btn-mdb-color.btn-rounded.btn-sm.my-0.ml-sm-2.waves-effect.waves-light {
    line-height: normal;
    padding: 10px 15px;
}

p.product-desc {
    font-size: 14px;
    line-height: 1.8em;
    text-transform: capitalize;
}

img.gps-location {
    position: absolute;
    right: 25px;
    top: 15px;
    cursor: pointer;
}

#search-nearby-tab #pac-input,.searchinv,.search-box-inventroy input,.search-product input,#pac-input-for-search,#search-switch-tab #pac-input {
    width: 100%;
    font-size: 15px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.33;
    letter-spacing: normal;
    color: #8f9bb3;
    height: 48px;
    border-radius: 4px;
    border: solid 1px #e4e9f2;
    background-color: #f7f9fc;
    float: left;
    padding-right: 35px;
}

#pac-input-for-search:valid~.gps-location {
    display: none;
}

.search-product input {
    float: none;
    padding: 0 10px;
    height: 38px;
}

.search-product {
    padding: 11px 15px 14px;
}

.search-box-inventroy input {
    height: 30px;
    width: 100%;
    border: none;
    padding-left: 10px;
    border-radius: 0;
}

a#nextbrand,a#nextshape,a#nextstore {
    cursor: pointer;
    position: relative;
    top: 5px;
    text-decoration: underline;
    color: #505050;
}

.search-box-inventroy .btn {
    width: 30px;
    height: 30px;
    margin: 0 0 0 -7px;
    border-radius: 0;
    border: none;
    padding: 0;
}

.booknsearch button.btn.searchbtn {
    float: right;
    font-size: .65em;
    border-radius: 0;
    padding: 4px;
    font-weight: 700;
}

.booknsearch .pricebold {
    float: left;
}

.booknsearch {
    overflow: hidden;
    margin-bottom: 10px;
}

.product-detail-search {
    overflow: hidden;
    margin: 0 0 20px;
}

p.text-center.no-result-found {
    font-size: 1.75em;
    padding: 5% 0%;
}

a.searchinventory.book-appointment.static-show {
    margin: 11px -11px -11px;
    border: none;
    border-radius: 0;
    background-color: #208178;
}

a.tel-mobile,.search-icon-mobile {
    display: none;
}

span.tittle {
    font-size: 1em;
}

span.productprice {
    font-size: 10px;
    margin: 0!important;
}

span.item-price {
    font-size: 1em;
    padding: 0!important;
    margin: 0!important;
}

span.sizeproduct {
    margin-top: 0!important;
    padding-top: 10px;
    font-size: 10px;
}

span.sizeproduct {
    padding-top: 0;
}

span.pricebold {
    font-weight: 700!important;
}

p.pricebold {
    display: -webkit-inline-box;
}

span.item-price {
    padding-left: 4%!important;
}

p.pricebold {
    font-weight: 700!important;
    margin-bottom: 0;
}

span.genderimg {
    position: absolute;
    right: 10%;
    top: 60%;
}

span.showimgsicon {
    position: absolute;
    right: 10%;
    top: 45%;
}

a.removemargintop.book-appointment.static-show {
    margin: 0;
}

.glassbox:hover a.removemargintop.book-appointment.static-show {
    margin-top: 20px;
}

.product-detail-search {
    overflow: hidden;
    margin: 0 0 20px;
}

.product-detail-search .product-name {
    float: left;
}

.product-detail-search .product-size {
    float: right;
    margin: 5px 0 0;
}

.near-search-store {
    font-size: 12px;
}

.product-slider .near-search-store span {
    float: right;
    font-weight: 700;
}

p.gst-included-price {
    height: 32px;
    background-color: #208178;
    color: #fff;
    text-align: center;
    padding: 7px 0;
    font-size: 14px;
    font-weight: 500;
    box-sizing: border-box;
}

 .carousel {
    margin-left: 50px;
}
/*
.carousel-inner img {
    width: 100%;
    height: 100%;
}

.carousel-indicators {
    display: inline-block;
    height: 300px;
    overflow-y: scroll;
    overflow-x: hidden;
    position: static;
    direction: rtl;
}  */

@media screen and (max-width:992px) {
    .carousel-indicators {
        display: inline-flex;
        direction: inherit;
        height: auto;
        width: 100%;
        max-width: 800px;
        overflow-x: auto;
        position: relative;
        margin-left: 0;
        margin-right: 0;
        overflow-y: hidden;
        justify-content: normal;
        margin-bottom: 20px;
    }

    .carousel-inner {
        margin-left: 0!important;
    }
}

::-webkit-scrollbar {
    width: 5px;
    height: 5px;
}

::-webkit-scrollbar-track {
    background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
    background: #888;
}

::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.item {
    margin-bottom: 10px;
    margin-left: 10px;
    cursor: pointer;
}

.item.active img {
    border: 1px solid red;
    opacity: 1;
}

.item img {
    border: 1px solid transparent;
    opacity: .5;
    transition: .5s;
}

.item:hover img {
    border: 1px solid red;
    opacity: 1;
}

.content {
    position: absolute;
    bottom: 0;
    background: rgba(0,0,0,.5);
    color: #f1f1f1;
    width: 100%;
    padding: 10px;
}

.content p {
    font-size: 15px;
}

.new-popup-form .day-block,.new-popup-form .day-block:hover,.new-popup-form .day-block.active {
    background: 0 0;
}

.new-popup-form .day-block.active .slot-date {
    color: #4bb3a0;
}

.new-popup-form .day-block .slot-date {
    width: 40px;
    margin-bottom: 20px;
    font-weight: 400;
}

.new-popup-form .day-block .slot-time {
    font-weight: 700;
    width: 40px;
    height: 40px;
    display: table-cell;
    vertical-align: middle;
}

.new-popup-form .day-block.active .slot-time {
    background: #4bb3a0;
    border-radius: 50%;
    color: #fff;
}

.new-popup-form .day-block {
    color: #505050;
    font-size: 16px;
}

.new-popup-form .select-day-time {
    border: none;
    padding-left: 0;
    padding-right: 0;
}

.new-popup-form .time-slot-field-wrapper {
    background: #f3f4f8;
    margin: 0 -16px;
    padding: 15px;
    box-shadow: inset 0 5px 10px 1px #c2c5cc;
}

.new-popup-form .time-slot {
    background: #fff;
    margin-bottom: 10px;
    margin-top: 10px;
    box-shadow: 0 0 3px #333;
    margin-right: 17px;
    border: 2px solid transparent;
    padding: 10px 0;
}

.new-popup-form .time-slot-field {
    text-align: left;
}

.new-popup-form .disabled {
    background: #e8e9ed;
    color: #b5b6ba;
}

.new-popup-form .time-slot-field .slot-all {
    margin-top: 20px;
    text-align: center;
}

.new-popup-form .optional {
    margin-top: 10px;
}

.new-popup-form .row.select-slots {
    padding: 0 0 20px;
    display: block;
}

.new-popup-form .row.select-slots {
    border-top: 1px solid #e4e9f2;
    padding-top: 15px;
    padding-bottom: 15px;
}

.new-popup-form .row.select-slots span {
    border: 1px solid #e4e9f2;
    border-radius: 5px;
    display: inline-block;
    padding: 10px 20px;
}

.new-popup-form .row.select-slots span.active {
    background: #4bb3a0;
    border: 1px solid #e4e9f2;
    color: #fff;
}

.new-popup-form .day-block,.new-popup-form .day-block:hover,.new-popup-form .day-block.active {
    background: 0 0;
}

.new-popup-form .day-block.active .slot-date {
    color: #4bb3a0;
}

.new-popup-form .day-block .slot-date {
    width: 40px;
    margin-bottom: 20px;
    font-weight: 400;
}

.new-popup-form .day-block .slot-time {
    font-weight: 700;
    width: 40px;
    height: 40px;
    display: table-cell;
    vertical-align: middle;
}

.new-popup-form .day-block.active .slot-time {
    background: #4bb3a0;
    border-radius: 50%;
    color: #fff;
}

.new-popup-form .day-block {
    color: #505050;
    font-size: 16px;
}

.new-popup-form .select-day-time {
    border: none;
    padding-left: 0;
    padding-right: 0;
}

.new-popup-form .time-slot-field-wrapper {
    background: #f3f4f8;
    margin: 0 -16px;
    padding: 15px;
    box-shadow: inset 0 5px 10px 1px #c2c5cc;
}

.new-popup-form .time-slot {
    background: #fff;
    margin-bottom: 10px;
    margin-top: 10px;
    box-shadow: 0 0 3px #333;
    margin-right: 17px;
    border: 2px solid transparent;
    padding: 10px 0;
}

.new-popup-form .time-slot-field {
    text-align: left;
}

.new-popup-form .disabled {
    background: #e8e9ed;
    color: #b5b6ba;
}

.new-popup-form .time-slot-field .slot-all {
    margin-top: 20px;
    text-align: center;
    font-weight: bolder;
    font-size: 9px;
    left: 5px;
    position: relative;
}

.new-popup-form .optional {
    margin-top: 10px;
}

.new-popup-form .row.select-slots {
    padding: 0 0 20px;
    display: block;
}

.new-popup-form .row.select-slots {
    border-top: 1px solid #e4e9f2;
    padding-top: 15px;
    padding-bottom: 15px;
}

.new-popup-form .row.select-slots span {
    border: 1px solid #707070;
    border-radius: 5px;
    display: inline-block;
    cursor: pointer;
    text-transform: capitalize;
    font-weight: revert;
}

.new-popup-form .row.select-slots span.active {
    background: #4bb3a0;
    border: 1px solid #e4e9f2;
    color: #fff;
}

@media screen and (max-width:992px) {
    .content {
        position: static;
    }

    .new-popup-form .time-slot {
        margin-right: 10px;
    }
}

@media screen and (min-width:1440px) {
    .carousel-inner {
        margin-left: -60px;
    }

    #corona-notif img {
        margin: 0 100px!important;
    }
}

@media screen and (min-width:1200px) and (max-width:1439px) {
    .carousel-inner {
        margin-left: -20px;
    }

    #corona-notif img {
        margin: 0 100px!important;
    }
}

@media screen and (min-width:880px) and (max-width:1199px) {
    .carousel-inner {
        margin-left: 20px;
    }

    .content {
        position: static;
    }

    #corona-notif img {
        margin: 0 100px!important;
    }
}

@media screen and (min-width:576px) and (max-width:879px) {
    .carousel-inner {
        margin-left: 50px;
    }

    .content {
        position: static;
    }
}

.vert .carousel-item-next.carousel-item-left,.vert .carousel-item-prev.carousel-item-right {
    transform: translate3d(0,0,0);
}

.vert .carousel-item-next,.vert .active.carousel-item-right {
    transform: translate3d(0,100% 0);
}

.vert .carousel-item-prev,.vert .active.carousel-item-left {
    transform: translate3d(0,-100%,0);
}

h1.no-inventory-found {
    font-size: 3em!important;
    color: #444;
    text-align: center!important;
    padding: 3%;
}

h1.no-inventory-found {
    font-size: 2em!important;
    padding: 5% 9%;
}

span.closed {
    color: #ec0a0a!important;
}

div.disabled-till-date-check {
    background: #e8e9ed;
}

.inner-tab-box {
    text-align: right;
    padding-bottom: 25px;
    padding-top: 10px;
}

#search-switch-tab p {
    text-align: left;
    padding-top: 30px;
    clear: both;
}

.inner-tab-box .inner-tab-title {
    width: 100%;
}

.store-locator .custom-tab-box ul li a,.store-locator .custom-tab-box ul li a.active {
    border: none;
}

.store-locator .custom-tab-box ul li a.active {
    background-color: #39bcd3;
    border-radius: 30px;
}

.store-locator .custom-tab-box ul li a {
    width: 15px;
    height: 15px;
    display: inline-block;
}

.store-locator .custom-tab-box ul {
    display: flex;
    background: rgb(31 47 70);
    transition: all .7s linear;
    border-radius: 30px;
    margin-left: 20px;
    padding: 4px 4px 1px;
    margin-bottom: 0;
    margin-top: -3px;
    width: 39px;
    float: right;
}

.store-locator .custom-tab-box ul li.advance-tab {
    line-height: 36px;
    margin-right: 30px;
}

.custom-tab-box {
    padding-top: 6px;
}

#content.detail-search .mobile-tab-view #tabsJustifiedContent {
    text-align: left;
}

.mobile-tab-view .nav-tabs {
    border: none;
    flex-wrap: nowrap;
    display: flex;
    overflow-y: auto;
    padding-bottom: 10px;
    margin-top: 20px;
    margin-bottom: 10px;
}

.mobile-tab-view .nav-tabs li {
    padding: 0 18px 0 0;
}

.mobile-tab-view iframe {
    height: 220px!important;
}

.mobile-tab-view .rj-offer-desk,.mobile-tab-view #google-reviews,.mobile-tab-view .popular-product {
    margin-top: 0;
}

.mobile-tab-view .nav-tabs .nav-link {
    border: none;
    color: #495057;
    border-bottom: 2px solid transparent;
    padding: 5px 0;
    width: max-content;
    font-size: 16px;
    font-family: Merriweather Sans, sans-serif;
    font-weight: 600;
}

.mobile-tab-view .nav-tabs .nav-link.active {
    border-bottom: 2px solid #f26638;
}

.mobile-tab-view {
    display: none;
}

.mobile-tab-view .fixed-call a {
    position: static!important;
    border-radius: 5px!important;
}

.call-details.fixed-call {
    margin-top: 13px;
}

.search-box-wrapper {
    background: #edf1f7;
    padding: 15px;
    min-height: 362px;
    border-radius: 5px;
}

.main-home .store-locator {
    margin-top: 0;
}

.store-locator .custom-tab-box ul li {
    padding: 0;
    margin-bottom: 0;
}

.flickity-page-dots {
    display: none;
}

.spacing-with-padding {
    margin-bottom: 10px;
}

.carousel-cell {
    width: 100%;
    height: 362px;
    margin-right: 10px;
    border-radius: 5px;
}

.flickity-enabled.is-draggable {
    margin-top: 0;
}

.slider-with-tab .col-md-8 {
    float: right;
}

.home-page-container {
    width: 100%;
}

@media all and (max-width:1024px) {
    #search-nearby input.form-control.searchinv,.detail-search .storelocator-search input {
        height: 30px;
        width: 100%;
    }

    div.searchbox.inventory {
        position: relative;
        display: flex;
    }

    .sticky .nav-flex-icons {
        display: none;
    }

    button#searchinvbtn {
        margin-left: -5px!important;
        right: 0;
        width: 50px;
    }

    #header ul.nav-flex-icons li {
        font-size: 18px;
        text-align: center;
    }

    #free-eyecheckup {
        display: none;
    }

    .nav-flex-icons {
        padding-top: 11px;
        display: flex;
        text-align: center;
        padding-bottom: 10px;
    }

    .mobile-view {
        display: block;
    }

    #header .desktop-view {
        display: none!important;
    }

    a.tel-mobile,span.search-icon-mobile {
        display: none;
    }

    .call-details a {
        font-size: 11px;
        padding: 0 13%;
    }

    .list-view-sidebar {
        height: 400px;
    }

    iframe {
        height: 420px!important;
    }

    #list-view {
        min-height: 450px;
    }
}

@media all and (max-width:1023px) and (min-width:768px) {
    .store-locator #tabsJustified li a {
        padding: 0 16px;
        font-size: 12px;
    }

    .detail-search .tel span {
        margin-left: 15px;
    }

    .inner-tab-box {
        display: block;
        overflow: hidden;
    }

    .search-box-wrapper {
        min-height: 340px;
        padding-bottom: 0;
    }

    #tabsJustifiedContent .dropdown .dropdown-toggle,#tabsJustifiedContent .btn,#search-nearby-tab #pac-input,.searchinv,.search-box-inventroy input,#advanced-search .dropdown .btn {
        height: 34px;
    }

    .store-locator .custom-tab-box ul {
        width: 39px;
        float: right;
        margin-top: 8px;
    }

    .inner-tab-box .inner-tab-title {
        float: left;
    }

    span.advance-tab {
        margin-top: 12px;
        float: left;
    }

    .carousel-cell {
        height: 340px;
    }

    .carousel-cell img {
        width: 100%;
    }
}

@media all and (max-width:1024px) and (min-width:768px) {
    .loc-pin {
        max-width: 18px!important;
        margin-right: 10px;
        height: auto;
    }

    .search-nearby-location {
        padding: 0 15px;
        display: flex;
    }

    .call-details a {
        font-size: 10px;
        float: none;
        padding: 0 5%;
        margin-bottom: 15px;
        display: block;
        width: auto;
    }

    .detail-search .call-details a {
        width: 100%!important;
    }
}

@media all and (max-width:767px) {
    a.tel.redefining-width.r-d-cta-w {
        font-size: 10px;
    }

    a.store-details.r-d-cta-w {
        font-size: 10px!important;
    }

    .speak-experts.store-info.new-button-cta {
        margin-top: 20px;
    }

    a.r-d-cta-w {
        width: 100%!important;
        text-align: center;
        box-shadow: 0 10px 6px -6px rgba(0,0,0,.2);
        transition: all ease-in-out 300ms;
        font-size: 12px!important;
        line-height: 25px;
        padding: 0!important;
        border-radius: 5px;
        margin: 15px 0;
    }

    a.book-appointment.makeithideonscrolll.browse-inventory.redefining-width {
        transition: all .3s ease 0s;
        box-shadow: 0 15px 20px rgba(46,229,157,.4);
    }

    .slider-with-tab .flickity-enabled.is-draggable {
        margin-bottom: 15px;
    }

    .rj-offer-desk.showthis {
        display: none;
    }

    body #content.detail-search h1 {
        font-size: 20px;
        margin-top: 10px;
    }

    .rj-offer-desk.showthis {
        display: none!important;
    }

    .nearby-stores h2 {
        margin-top: 10px;
        font-size: 20px;
    }

    #search-nearby-tab p {
        display: none;
    }

    .spacing-with-padding {
        margin-bottom: 23px;
    }

    a#whatsappimage {
        left: 15px;
        right: 15px;
        background: 0 0;
        bottom: 7px;
        z-index: 9;
    }

    #scroll {
        bottom: 10px;
    }

    .flickity-page-dots {
        display: block;
        position: absolute;
        bottom: 5px;
    }

    .flickity-page-dots .dot {
        background: #fff;
        opacity: 1;
        margin: 0 5px;
    }

    .detail-search #carousel {
        margin-bottom: 0;
    }

    .nearby-stores {
        margin-top: 0;
    }

    .detail-search .lenskart-gallery-slider {
        min-height: 0;
    }

    .detail-search .lenskart-gallery-slider ul li img {
        height: 260px;
    }

    .detail-search #carousel img {
        height: 135px;
    }

    #tabsJustifiedContent .dropdown .dropdown-toggle {
        height: 48px;
    }

    #search-switch-tab p {
        text-align: center;
    }

    #search-switch-tab .btn {
        margin-top: 0!important;
    }

    .flickity-page-dots .dot.is-selected {
        background: #c4161c;
    }

    .flickity-prev-next-button.previous,.flickity-prev-next-button.next {
        display: none;
    }

    .search-box-wrapper {
        min-height: 0;
    }

    .slider-with-tab .col-md-8 {
        float: none;
        display: none;
    }

    #tabsJustifiedContent .dropdown .dropdown-toggle {
        margin-top: 0;
    }

    .carousel-cell {
        height: 120px;
    }

    .carousel-cell img {
        width: 100%;
    }

    .mobile-tab-view {
        display: block;
    }

    .sidebar-desktop {
        display: none;
    }

    .mobile-tab-view .col-md-12 {
        padding: 0;
    }

    .new-popup-form .time-slot-field .col-md-3 {
        flex: 0 0 25%;
        max-width: 25%;
        padding-right: 0;
        padding-left: 0;
    }

    .new-popup-form .time-slot-field .col-md-9 {
        flex: 0 0 75%;
        max-width: 75%;
        padding-right: 0;
        margin-bottom: 8%;
    }

    .new-popup-form .time-slot {
        margin: 0 9px 25px;
        width: 25%;
    }

    .new-popup-form .day-group label {
        margin-bottom: 10px;
    }

    .new-popup-form .select-day-time {
        padding-top: 5px;
    }

    .new-popup-form .time-slot-field {
        text-align: left;
        margin: 18px 0;
    }

    .new-popup-form .submitBtnLead {
        margin-top: 0;
    }

    .new-popup-form .time-slot-field:last-child {
        text-align: left;
        margin: 18px 0 0;
    }

    .new-popup-form .row.select-slots span {
        padding: 10px 15px;
        font-size: 12px;
    }

    .new-popup-form .row.select-slots .col-md-6 {
        width: auto;
        padding: 0 10px;
    }

    .new-popup-form .optional input {
        width: 100%;
    }

    .store-address address .locality-store i {
        margin-top: -5px;
    }

    .locality-store {
        display: flex;
    }

    span.operational-time {
        display: flex;
    }

    span.sizeproduct {
        padding-bottom: 5%;
    }

    span.tittle {
        padding-top: 5%;
    }

    span.sizeproduct {
        position: absolute;
        right: 10%;
        top: 188px;
    }

    span.genderimg {
        position: absolute;
        right: 10%;
        top: 230px;
    }

    span.sizeproduct.gender {
        top: 200px;
    }

    span.sizeproduct {
        color: #444;
    }

    a.book-appointment.static-show {
        margin-top: 3%;
    }

    span.showimgsicon {
        position: absolute;
        right: 10%;
        top: 70%;
    }

    a.tel-mobile,span.search-icon-mobile {
        display: block;
    }

    div.searchbox.inventory {
        position: relative;
        display: flex;
    }

    .sticky .nav-flex-icons {
        display: none;
    }

    button#searchinvbtn {
        margin-left: -5px!important;
        right: 0;
        width: 50px;
    }

    #header ul.nav-flex-icons li {
        font-size: 18px;
        text-align: center;
        width: 100%;
    }

    .nav-flex-icons {
        padding-top: 5px;
        width: 100%;
        display: flex;
        text-align: center;
        padding-bottom: 10px;
    }

    .mobile-view {
        display: block;
    }

    #header .desktop-view {
        display: none;
    }

    #listingTable .flex-direction-nav a:before {
        font-size: 30px;
    }

    #search-nearby input.form-control.searchinv {
        width: 100%;
        background: #f7f9fc;
        height: 40px;
    }

    .sticky a.tel-mobile {
        display: block;
    }

    .rj-offer-desk.showthis {
        margin: 10px 0 0;
        padding-bottom: 15px;
        display: block;
    }

    .rj-offer-desk.showthis.home {
        display: block;
    }

    .rj-offer-desk.showthis.home {
        margin: 0 0 -25px 0;
    }

    #content h1 {
        font-size: 0;
    }

    img.img-responsive.small-banner {
        display: block;
    }

    a.browse-inventory {
        display: block;
    }

    main#content {
        margin-top: 15px;
    }

    a.book-appointment.static-show {
        position: static;
    }

    .detail-search .store-address a.book-appointment {
        z-index: 999;
    }

    a.book-appointment.makeithideonscrolll.browse-inventory.redefining-width {
        width: 100%!important;
    }

    .pagination {
        display: block;
    }

    .pagination li {
        display: inline-block;
        margin-top: 5px;
    }

    .list-map-view,.view-map {
        display: none;
    }

    .detail-search .book-appointment {
        position: fixed;
        bottom: 0;
        left: 0;
        right: 0;
        margin: 0 0;
        border-radius: 0;
        z-index: 99;
    }

    .detail-search.stick .book-appointment {
        position: static;
    }

    .detail-search .store-address {
        padding: 15px 10px 25px;
    }

    .store-address {
        padding: 10px 15px 15px;
    }

    .store-detail-info h2 {
        display: block;
        font-size: 20px;
        border-bottom: 1px solid #eee;
        margin-top: 5px;
        padding-bottom: 10px;
        font-weight: 700;
    }

    #content.detail-search .nearby-stores-content .store-info {
        width: 50%;
    }

    body {
        padding-top: 55px;
    }

    #advanced-search .dropdown {
        margin: 0 0 15px;
        width: 100%;
        display: inline-block;
    }

    .advanced-search-main {
        display: inline-block;
    }

    #tabsJustifiedContent .btn {
    }

    .col-lg-5.spacing-with-padding {
        padding-bottom: 15px;
    }

    #search-nearby input.form-control {
        width: 66%;
    }

    .detail-search .storelocator-search input {
        width: 100%;
    }

    iframe {
        height: 300px;
    }

    #mapOnSearch {
        height: 300px;
    }

    .call-details a {
        font-size: 13px;
        padding: 0 10%;
    }

    .store-locator .custom-tab-box ul li a {
        width: 15px;
        height: 15px;
    }

    #tabsJustifiedContent .btn {
        margin-top: 10px;
    }

    .nearby-stores-content ul {
        display: block;
    }

    .nearby-stores-content ul li {
        display: inline-block;
        width: 47%;
        margin-bottom: 20px;
        margin-right: 20px;
    }

    .nearby-stores-content ul li:nth-child(even) {
        margin-right: 0;
    }

    .nav-flex-icons {
        padding-top: 8px;
        float: right;
    }

    .map-view-stores ul li a.nav-link {
        padding-left: 6px;
        padding-right: 6px;
    }

    .map-view-stores h2 {
        padding-right: 30px;
    }

    .container {
        max-width: 100%;
    }

    .list-view-sidebar {
        border-bottom: solid 1px #c4161c;
    }

    #content.detail-search .list-view-sidebar {
        border-bottom: none;
    }

    #listingTable .flex-direction-nav a {
        height: 30px;
        width: 30px;
    }
}

@media all and (max-width:479px) {
    .new-popup-form .time-slot-field .slot-all {
        padding-left: 5px;
        text-align: -webkit-auto;
    }

    #corona-notif span.text-center {
        font-size: 12px;
    }

    #corona-notif a {
        margin: 0 10px;
    }

    div#slidernew {
        margin: 0 0 18px;
    }

    #content.detail-search .nearby-stores-content .store-info {
        width: 100%;
    }

    div#carouselnew {
        border: none;
    }

    #listingTable .flex-direction-nav a:before {
        font-size: 22px;
    }

    #listingTable .flex-direction-nav a {
        height: 22px;
        width: 22px;
    }

    #carouselnew .flex-direction-nav a {
        top: 63%;
    }

    .map-view-stores {
        display: block;
    }

    #header ul.navbar-nav li.toll_free_number_national {
        float: left;
    }

    .sticky .nav-flex-icons {
        display: none;
    }

    .map-view-stores ul li a.nav-link {
        padding-left: 15px;
        padding-right: 15px;
    }

    .call-details a {
        font-size: 10px;
        padding: 0 2%;
        width: 49%;
    }

    a.browse-inventory.redefining-width.full-on-desktop.hideondesktop {
        display: block;
    }

    a.browse-inventory.redefining-width.full-on-desktop {
        width: 100%!important;
    }

    .nearby-stores-content ul li {
        width: 46%;
    }

    .imgs-grid.imgs-grid-4 .imgs-grid-image,.imgs-grid.imgs-grid-6 .imgs-grid-image {
        width: 100%;
        padding-right: 0;
    }

    .view-map {
        float: none;
        text-align: center;
    }

    .map-view-stores .nav-tabs li {
        margin-bottom: 0;
        display: inline-block;
        margin: 9px -3px 0 -4px;
    }

    .map-view-stores .nav-tabs {
        text-align: center;
        display: inline-block;
    }

    .map-view-stores h2 {
        text-align: center;
    }
}

@media all and (max-width:360px) {
    .new-popup-form .row.select-slots span {
        padding: 10px 13px;
    }

    .call-details a {
        font-size: 9px;
    }
}

@media all and (max-width:359px) {
    .custom-tab-box .store-address address {
        max-width: 60%;
    }

    .new-popup-form .day-block .slot-time {
        width: 30px;
        height: 30px;
        font-size: 13px;
    }

    .new-popup-form .day-block .slot-date {
        width: 30px;
        font-size: 13px;
    }

    .new-popup-form .time-slot {
        width: 23%;
        font-size: 12px;
    }

    .new-popup-form .row.select-slots span {
        padding: 10px 11px;
        font-size: 12px;
    }

    #appointment.new-popup-form .input-block label {
        font-size: 12px;
    }

    .call-details a {
        font-size: 10px;
    }
}

span.glassname {
    font-weight: 100;
}

.page-item.active .page-link {
    background-color: #208178;
    border-color: #208178;
}

.page-link {
    color: #218178;
}

.page-link:hover {
    color: #218178;
}

.site-map li.site-map-city a {
    color: #4d4d4f;
}

.site-map li.site-map-state a {
    color: #044963;
}

@media(max-width:767px) {
    .search-box-inventroy.detailpage {
        padding-left: 15px;
        padding-right: 15px;
    }

    #tabsJustifiedContent .search-box-inventroy.detailpage .btn {
        margin-top: 0;
    }

    #tabsJustifiedContent .search-box-inventroy.detailpage input {
        height: 48px;
    }
}

#flexbox {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    row-gap: 5px;
    text-align: center;
  }
  
  #flexbox > div {
    border: 1px solid white;
    background-color: #E5E5FF;
    flex: 1 1 auto;
    width: 220px;
  }
  .ant-tabs-nav-list {
    display: flex;
    align-items: center;
    width:80%;
  }
  .ant-tabs-tab {
    width: 50%;
    justify-content: center;
  }`, "",{"version":3,"sources":["webpack://./src/assets/style.css"],"names":[],"mappings":"AAAA;IACI,0CAA0C;IAC1C,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,WAAW;IACX,iBAAiB;AACrB;;;AAGA;IACI,2CAA2C;IAC3C,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;IAC1C,WAAW;AACf;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0CAA0C;IAC1C,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,OAAO;IACP,WAAW;IACX,MAAM;IACN,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IAGzB,uCAAuC;IACvC,gCAAgC;AACpC;;AAEA;IACI,0CAA0C;IAC1C,qBAAqB;IACrB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,0CAA0C;IAC1C,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,YAAY;IACZ,gCAAgC;IAChC,UAAU;IACV,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,SAAS;IACT,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,eAAe;IACf,UAAU;IACV,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAUA;IACI,cAAc;AAClB;;AAUA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,yBAAyB;IAGzB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,QAAQ;IACR,SAAS;IACT,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,yDAAyD;AAC7D;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IACP,WAAW;IACX,UAAU;IACV,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,MAAM;AACV;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,0CAA0C;AAC9C;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IAEzB,wBAAwB;IACxB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,uCAAuC;IACvC,eAAe;AACnB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,6EAA6E;IAC7E,kBAAkB;IAClB,YAAY;IACZ,OAAO;IACP,MAAM;IACN,WAAW;IACX,WAAW;AACf;;AAEA;IACI,+EAA+E;AACnF;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,UAAU;IACV,WAAW;IACX,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,0CAA0C;IAC1C,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,0BAA0B;IAC1B,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,yBAAyB;IACzB,kBAAkB;IAClB,SAAS;IACT,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,YAAY;IACZ,sBAAsB;IACtB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,MAAM;IACN,OAAO;AACX;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,0CAA0C;IAC1C,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,0CAA0C;AAC9C;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,WAAW;IACX,eAAe;IACf,0CAA0C;IAC1C,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,cAAc;IACd,0CAA0C;IAC1C,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;AACA;;;;;;;;;;;;;;;;;;;;;GAqBG;;AAEH;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,SAAS;IACT,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,UAAU;AACd;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,+BAA+B;IAC/B,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,0CAA0C;IAC1C,yBAAyB;IACzB,kBAAkB;IAClB,OAAO;IACP,iBAAiB;IACjB,MAAM;IACN,QAAQ;IACR,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,SAAS;AACb;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,SAAS;IACT,aAAa;IACb,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,UAAU;AACd;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,UAAU;IACV,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,SAAS;IACT,kBAAkB;IAClB,UAAU;IACV,0BAA0B;IAC1B,WAAW;IACX,WAAW;IACX,UAAU;IACV,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,qBAAqB;IACrB,sBAAsB;IACtB,UAAU;IACV,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,UAAU;IACV,0CAA0C;IAC1C,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,0CAA0C;AAC9C;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,yBAAyB;IACzB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,WAAW;IACX,SAAS;IACT,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,eAAe;IACf,yBAAyB;IACzB,0CAA0C;IAC1C,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,0CAA0C;IAC1C,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,qBAAqB;IACrB,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,qCAAqC;IACrC,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,0BAA0B;AAC9B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,QAAQ;IACR,0BAA0B;IAC1B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,UAAU;AACd;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,gBAAgB;IAEhB,sBAAsB;AAC1B;;CAEC;IACG,iBAAiB;AACrB;AACA;;;;;;;;;;;;;IAaI;;AAEJ;IACI;QACI,oBAAoB;QACpB,kBAAkB;QAClB,YAAY;QACZ,WAAW;QACX,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB;QAClB,cAAc;QACd,eAAe;QACf,kBAAkB;QAClB,uBAAuB;QACvB,mBAAmB;IACvB;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,0BAA0B;IAC1B,cAAc;IACd,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,aAAa;IAEb,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,eAAe;IACf,aAAa;IAEb,wCAAwC;AAC5C;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,qBAAqB;IACrB,eAAe;IACf,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI;QACI,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;IACpB;AACJ;;AAEA;IAEI,6BAA6B;AACjC;;AAEA;IAEI,gCAAgC;AACpC;;AAEA;IAEI,iCAAiC;AACrC;;AAEA;IACI,wBAAwB;IACxB,WAAW;IACX,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,0BAA0B;IAC1B,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,gBAAgB;IAChB,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,oCAAoC;IACpC,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,0CAA0C;IAC1C,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,2BAA2B;QAC3B,QAAQ;QACR,WAAW;IACf;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iBAAiB;QACjB,aAAa;QACb,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,WAAW;QACX,aAAa;QACb,mBAAmB;QACnB,cAAc;QACd,WAAW;IACf;;IAEA;QACI,qBAAqB;IACzB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,qBAAqB;QACrB,kBAAkB;QAClB,0CAA0C;QAC1C,iCAAiC;QACjC,yBAAyB;QACzB,iBAAiB;QACjB,oBAAoB;QACpB,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,2BAA2B;QAC3B,2CAA2C;IAC/C;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,WAAW;QACX,eAAe;QACf,WAAW;QACX,UAAU;IACd;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,UAAU;IACd;;IAEA;QAEI,aAAa;QACb,cAAc;QACd,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QAEI,aAAa;QACb,cAAc;QACd,gBAAgB;QAChB,iBAAiB;IACrB;;IAEA;QACI,kBAAkB;QAClB,UAAU;IACd;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,UAAU;IACd;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,QAAQ;IACZ;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,2BAA2B;QAC3B,QAAQ;QACR,WAAW;IACf;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,aAAa;QACb,kBAAkB;QAClB,oBAAoB;IACxB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;QAChB,oBAAoB;QACpB,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,qBAAqB;QACrB,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,SAAS;QACT,OAAO;QACP,QAAQ;QACR,WAAW;QACX,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,cAAc;QACd,eAAe;QACf,6BAA6B;QAC7B,eAAe;QACf,oBAAoB;QACpB,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;IACA;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,qBAAqB;QACrB,UAAU;QACV,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,wBAAwB;IAC5B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,aAAa;QACb,UAAU;IACd;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,gBAAgB;QAChB,qBAAqB;QACrB,uBAAuB;IAC3B;;IAEA;QACI,kBAAkB;QAClB,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,kBAAkB;QAClB,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;IACd,YAAY;EACd;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;EACA;IACE,UAAU;IACV,uBAAuB;EACzB","sourcesContent":["body {\n    font-family: Merriweather Sans, sans-serif;\n    font-size: 14px;\n    font-weight: 700;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.14;\n    letter-spacing: normal;\n    color: #444;\n    padding-top: 60px;\n}\n\n\nh1 {\n    font-family:  Merriweather Sans, sans-serif;\n    font-size: 0;\n    font-weight: 400;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.33;\n    letter-spacing: normal;\n    text-align: center;\n    color: #fff;\n}\n\np {\n    font-family: Merriweather Sans, sans-serif;\n}\n\nh2,h3,h4 {\n    font-family: Merriweather Sans, sans-serif;\n    color: #444;\n}\n\ninput,button {\n    font-family: Merriweather Sans, sans-serif;\n}\n\nimg {\n    max-width: 100%;\n}\n\naddress {\n    font-family: Merriweather Sans, sans-serif;\n    font-size: 14px;\n    font-weight: 400;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.5;\n    letter-spacing: normal;\n    color: #2e3a59;\n}\n\n.d-flex.about-lenskart {\n    margin-top: 30px;\n}\n\n.store-address address i {\n    font-size: 18px;\n    margin-right: 10px;\n    margin-top: 3px;\n}\n\n.store-address address .locality-store i {\n    margin-right: 8px;\n    margin-left: -3px;\n}\n\na.store-directions {\n    display: flex;\n    color: #2e3a59;\n    margin-top: 18px;\n}\n\n.contact-info-list li .inventory-icon svg {\n    width: 27px;\n    fill: #c4161c;\n}\n\na.store-directions i {\n    width: 30px;\n    margin: -3px 3px 0 -5px;\n}\n\n.speak-experts span {\n    display: block;\n    margin-bottom: 18px;\n    font-size: 17px;\n    margin-top: 0;\n    text-align: center;\n    font-family: Merriweather Sans, sans-serif;\n}\n\n#content.detail-search .speak-experts.store-info {\n    padding: 20px 20px 18px;\n}\n\n.tab-content.custom-tab-box .locality-store {\n    margin-top: 18px;\n    margin-bottom: 18px;\n}\n\n.detail-search .speak-experts .call-details a {\n    font-size: 13px;\n}\n\n.detail-search .store-address address .locality-store i {\n    margin-right: 7px;\n}\n\nspan.upper-address {\n    display: flex;\n    margin-left: -5px;\n}\n\naddress a {\n    color: #c4161c;\n    text-decoration: underline;\n}\n\naddress a:hover {\n    text-decoration: none;\n}\n\n.list-view-sidebar::-webkit-scrollbar {\n    width: 5px;\n    position: relative;\n    top: 30px;\n}\n\n.list-view-sidebar::-webkit-scrollbar-thumb {\n    background: #a6a6a6;\n    position: relative;\n    top: 30px;\n}\n\n.list-view-sidebar::-webkit-scrollbar-thumb:hover {\n    background: #c4161c;\n}\n\n.flash-message.top-flashmessage {\n    margin: 0;\n    margin-top: -6px;\n    background: #fde3bc;\n}\n\n.time-slot.disabled.blockthis {\n    pointer-events: all;\n    cursor: pointer;\n}\n\n.tel {\n    color: #2e3a59;\n    text-decoration: none;\n    display: inline-block;\n    margin: 13px 0 3px;\n}\n\n.store-timing {\n    display: block;\n    margin-top: 10px;\n}\n\n.btn {\n    border-radius: 4px;\n    background-color: #c4161c;\n    font-size: 14px;\n    font-weight: 700;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.14;\n    letter-spacing: normal;\n    text-align: center;\n    color: #fff;\n    text-transform: uppercase;\n}\n\n.btn:hover {\n    background: #d76c70;\n}\n\n.form-control:focus,.btn:focus {\n    box-shadow: none;\n}\n\na {\n    transition: .3s;\n}\n\n#header {\n    border-bottom: solid 3px #e4e9f2;\n    position: fixed;\n    left: 0;\n    width: 100%;\n    top: 0;\n    transition: .4s;\n    background: #fff;\n    z-index: 999;\n}\n\n#header.sticky {\n    background-color: #f7f9fc;\n    -webkit-box-shadow: 0 3px 5px rgba(57,63,72,.3);\n    -moz-box-shadow: 0 3px 5px rgba(57,63,72,.3);\n    box-shadow: 0 3px 5px rgba(57,63,72,.3);\n    border-bottom: solid 3px #c4161c;\n}\n\n#header ul li {\n    font-family: Merriweather Sans, sans-serif;\n    display: inline-block;\n    color: #444;\n    font-weight: 600;\n    font-size: 15px;\n    line-height: 29px;\n}\n\n#header ul li a {\n    color: #444;\n    padding: 5px 14px;\n    transition: .4s;\n}\n\n#header ul.main-nav li a:hover {\n    background: #c4161c;\n    color: #fff;\n}\n\n#header ul.nav-flex-icons li {\n    font-size: 20px;\n}\n\n#header ul.nav-flex-icons li a {\n    padding: 0 10px;\n}\n\n#header ul.nav-flex-icons li a:hover {\n    color: #1e8178;\n}\n\n#header ul.navbar-nav li.toll_free_number_national {\n    font-size: 16px;\n    font-weight: 400;\n}\n\n#header ul.navbar-nav li.toll_free_number_national i {\n    font-style: normal;\n}\n\n#header ul.navbar-nav li.toll_free_number_national a {\n    font-weight: 500;\n}\n\n#corona-notif a {\n    display: inline-block;\n    text-align: center;\n    margin: 0 10px;\n    text-decoration: none;\n}\n\n#corona-notif span.text-center {\n    display: block;\n    margin-top: 5px;\n}\n\n.navbar-brand {\n    padding: 0;\n}\n\n.navbar-light {\n    background: #dcdbd4;\n    margin-bottom: 10px;\n    padding: 0;\n}\n\n.upper-part {\n    display: flex;\n    padding: 4px 0;\n}\n\n.nav-flex-icons {\n    padding-top: 12px;\n}\n\n#content h1 {\n    text-align: center;\n}\n\n.flash-message {\n    background: #c9edea;\n    text-align: center;\n    padding: 10px 0;\n    margin: 20px 0;\n}\n\n.flash-message p {\n    margin-bottom: 0;\n    font-weight: 400;\n}\n\n.store-locator {\n    margin-top: 30px;\n}\n\n.store-locator ul {\n    display: block;\n    border: none;\n    margin: 3px 0;\n}\n\n.store-locator ul li {\n    display: inline-block;\n    font-size: 14px;\n    font-family: Merriweather Sans, sans-serif;\n    text-transform: uppercase;\n    font-weight: 700;\n}\n\n.store-locator #tabsJustified li a {\n    border: none;\n    padding: 0 19px;\n    border-radius: 5px;\n}\n\n.store-locator #tabsJustified li a.active {\n    background: #c4161c;\n    color: #fff;\n}\n\n.store-locator ul li a.nav-link {\n    display: inline-block;\n    border: none;\n    border-bottom: 5px solid #8f9bb3;\n    padding: 0;\n    color: #444;\n    line-height: 34px;\n}\n\n.map-view-stores ul li a.nav-link {\n    border: 1px solid #8f9bb3;\n    color: #8f9bb3;\n    font-size: 11px;\n    font-weight: 400;\n}\n\n.map-view-stores ul li a.nav-link i {\n    margin-right: 10px;\n}\n\n.map-view-stores ul li:first-child a {\n    border-radius: 4px 0 0 4px;\n}\n\n.map-view-stores ul li:last-child a {\n    border-radius: 0 4px 4px 0;\n    border-left: 1px solid transparent;\n}\n\n.map-view-stores ul li a.nav-link:hover {\n    border: 1px solid #c4161c;\n}\n\n.map-view-stores ul li a.nav-link.active {\n    border: 1px solid #c4161c;\n    background-color: #c4161c;\n    color: #fff;\n}\n\n.map-view-stores .nav-tabs {\n    border-radius: 0;\n    margin-bottom: 0;\n    border: none;\n}\n\n.map-view-stores .nav-tabs li {\n    margin-bottom: 0;\n}\n\n.store-locator ul li a.nav-link.active {\n    border: none;\n    color: #c4161c;\n    border-bottom: 5px solid #1e8178;\n    background: 0 0;\n}\n\n#tabsJustifiedContent {\n    text-align: center;\n}\n\n#search-nearby input.form-control,.detail-search .storelocator-search input,.searchinv {\n    width: 80%;\n    font-size: 15px;\n    font-weight: 400;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.33;\n    letter-spacing: normal;\n    color: #8f9bb3;\n    height: 48px;\n    border-radius: 4px;\n    border: solid 1px #e4e9f2;\n    background-color: #f7f9fc;\n    float: left;\n    padding-right: 35px;\n}\n\n#search-nearby input.form-control:focus {\n    background: rgba(21,110,110,.11);\n}\n\n#tabsJustifiedContent .btn {\n    height: 48px;\n    float: right;\n    width: 100%;\n}\n\n#tabsJustifiedContent .form-inline {\n    display: block;\n}\n\n.dropdown-menu.radio .dropdown-item {\n    position: relative;\n    overflow: hidden;\n    cursor: pointer;\n}\n\n.dropdown-menu.radio input {\n    visibility: hidden;\n    position: absolute;\n    left: -30px;\n}\n\n.dropdown-menu.radio i {\n    font-weight: 400;\n    font-style: normal;\n    display: block;\n}\n\n.dropdown-menu.radio input {\n    visibility: hidden;\n    position: absolute;\n    left: -30px;\n}\n\n.dropdown-menu.radio i {\n    font-weight: 400;\n    font-style: normal;\n    display: block;\n}\n\n.dropdown-item.active {\n    background-color: #555;\n    color: #fff;\n}\n\nmain#content {\n    margin-top: 30px;\n}\n\n.mobile-view {\n    transition: .4s;\n    width: 0;\n    padding: 0;\n    overflow: hidden;\n    margin: 0;\n}\n\n.navbar-fixed-top .mobile-view {\n    width: 214px;\n}\n\n.main-nav {\n    transition: .4s;\n}\n\n.navbar .row {\n    width: 100%;\n}\n\n.navbar .nav-flex-icons {\n    position: absolute;\n    top: 0;\n    right: -15px;\n    opacity: 0;\n    transition: .4s;\n}\n\n.navbar-fixed-top.navbar .nav-flex-icons {\n    opacity: 1;\n}\n\n.advanced-search-main {\n    width: 100%;\n}\n\n#advanced-search .dropdown {\n    display: flex;\n    margin: 0 0 10px;\n    width: 100%;\n}\n\n.dropdown-menu {\n    width: 100%;\n}\n\n#advanced-search .dropdown .btn {\n    width: 100%;\n    margin-left: 0!important;\n}\n\n#tabsJustifiedContent .dropdown .dropdown-toggle {\n    font-size: 15px;\n    font-weight: 400;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.33;\n    letter-spacing: normal;\n    color: #8f9bb3;\n    height: 40px;\n    border-radius: 4px;\n    border: solid 1px #e4e9f2;\n    background-color: #f7f9fc;\n    width: 100%;\n}\n\n#tabsJustifiedContent .dropdown .dropdown-toggle ins {\n    text-decoration: none;\n    float: left;\n    text-transform: none;\n}\n\n#search-switch-tab .btn {\n    margin-top: 20px!important;\n}\n\n#search-switch-tab input {\n    height: 48px;\n}\n\n#tabsJustifiedContent .dropdown-toggle::after {\n    position: absolute;\n    right: 15px;\n    top: 23px;\n}\n\n#advanced-search .dropdown.show .dropdown-toggle::after {\n    border-top: 0;\n    border-right: .3em solid transparent;\n    border-bottom: .3em solid;\n    border-left: .3em solid transparent;\n}\n\n.dropdown-item.active {\n    background: #1e8178;\n}\n\n.map-view-stores h2 {\n    font-size: 14px;\n    font-weight: 700;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 28px;\n    letter-spacing: normal;\n    color: #2e3a59;\n    margin: 0;\n    text-transform: uppercase;\n}\n\n.map-view-stores {\n    display: flex;\n    border-radius: 4px;\n    background-color: #edf1f7;\n    margin: 25px 0 0;\n    padding: 10px 15px;\n}\n\n.detail-search .storelocator-search input {\n    padding-left: 35px;\n    border: 1px solid #156e6e;\n    color: #156e6e;\n    font-weight: 700;\n    width: 100%;\n}\n\n#content.detail-search h1 {\n    text-align: left;\n    font-size: 26px;\n    margin-bottom: 5px;\n}\n\n#content.detail-search .list-view-sidebar {\n    height: auto;\n    overflow: visible;\n    margin-top: 0;\n    margin-bottom: 0;\n    position: relative;\n}\n\n#content.detail-search #list-view {\n    background: 0 0;\n}\n\n#content.detail-search .store-info {\n    background: #edf1f7;\n    border-radius: 5px;\n    padding: 0;\n}\n\n#content.detail-search .nearby-stores-content .store-info {\n    background: 0 0;\n    padding: 0;\n    width: 25%;\n    box-shadow: none;\n}\n\n.detail-search .store-address {\n    padding: 10px 15px 15px;\n}\n\n#content.detail-search .nearby-stores-content .store-info .store-address {\n    padding: 15px 10px;\n    margin: 0 5px;\n    display: block;\n    border: 1px solid #c4161c;\n    color: #c4161c;\n    border-radius: 5px;\n}\n\n#content.detail-search .nearby-stores-content .store-info .store-address:hover {\n    text-decoration: none;\n    background: #c4161c;\n    color: #fff;\n}\n\n#content.detail-search .nearby-stores-content .store-info .store-address span {\n    display: block;\n    margin-bottom: 10px;\n    font-size: 15px;\n}\n\n#content.detail-search .nearby-stores-content .store-info .store-address span a {\n    color: #444;\n    text-decoration: underline;\n}\n\n#content.detail-search .nearby-stores-content .store-info .store-address span a:hover {\n    text-decoration: none;\n}\n\n.store-tags {\n    margin-top: 20px;\n}\n\n.store-tags+.store-tags {\n    margin-top: 0;\n}\n\n.about-lenskart h4 {\n    text-align: left;\n}\n\n.detail-search .storelocator-search input::-webkit-input-placeholder {\n    color: #156e6e;\n}\n\n.detail-search .storelocator-search input:-ms-input-placeholder {\n    color: #156e6e;\n}\n\n.detail-search .storelocator-search input::placeholder {\n    color: #156e6e;\n}\n\n.detail-search .store-inventory.storelocator-search input::-webkit-input-placeholder {\n    color: #8f9bb3;\n}\n\n.detail-search .store-inventory.storelocator-search input:-ms-input-placeholder {\n    color: #8f9bb3;\n}\n\n.detail-search .store-inventory.storelocator-search input::placeholder {\n    color: #8f9bb3;\n}\n\n.search-inventory-page .glassimg {\n    min-height: 115px;\n    padding-top: 0;\n    padding-bottom: 10px;\n}\n\n.filter-box {\n    display: block;\n    position: relative;\n    padding-left: 23px;\n    margin-bottom: 12px;\n    cursor: pointer;\n    font-size: 14px;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    font-weight: 400;\n}\n\n.filter-box input {\n    position: absolute;\n    opacity: 0;\n    cursor: pointer;\n    height: 0;\n    width: 0;\n}\n\n.checkmark {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 16px;\n    width: 16px;\n    background-color: #44444478;\n}\n\n.filter-container:last-child {\n    border: none;\n}\n\n.filter-search {\n    overflow: hidden;\n    padding-bottom: 20px;\n}\n\n.search-box-inventroy {\n    float: left;\n    display: flex;\n}\n\n.sort-inventroy {\n    float: right;\n    text-align: right;\n}\n\n.sort-inventroy select {\n    -webkit-appearance: none;\n    background: #f5f5f5;\n    padding: 10px 15px;\n    border: none;\n    border-radius: 0;\n    cursor: pointer;\n    display: inline-block;\n    outline: none;\n    margin: 0 0 0 9px;\n}\n\n.select {\n    position: relative;\n}\n\n.select-arrow {\n    position: absolute;\n    top: 16px;\n    right: 15px;\n    width: 0;\n    height: 0;\n    pointer-events: none;\n    border-style: solid;\n    border-width: 8px 5px 0;\n    border-color: #7b7b7b transparent transparent transparent;\n}\n\n.search-inventory-page .popular-product {\n    margin-top: 0;\n}\n\n.filter-box:hover input~.checkmark {\n    background-color: #ccc;\n}\n\n.filter-box input:checked~.checkmark {\n    background-color: #156e6e;\n}\n\n.checkmark:after {\n    content: \"\";\n    position: absolute;\n    display: none;\n}\n\n.filter-box input:checked~.checkmark:after {\n    display: block;\n}\n\na.canvasjs-chart-credit {\n    display: none;\n}\n\n.chart-graph:before {\n    content: \"\";\n    height: 10px;\n    background: #fff;\n    position: absolute;\n    left: 0;\n    width: 63px;\n    z-index: 9;\n    bottom: 2px;\n}\n\n.chart-graph {\n    position: relative;\n    margin-top: 32px!important;\n}\n\n.graphflexslider {\n    position: relative;\n    padding: 10px 0;\n}\n\n.contact-info-list {\n    list-style: none;\n    padding: 0 0 15px;\n    position: absolute;\n    right: 10px;\n    top: 0;\n}\n\n.contact-info-list li {\n    text-align: center;\n}\n\n.contact-info-list li i {\n    width: 40px;\n    line-height: 40px;\n    border-radius: 50%;\n    border: 1px solid #c4161c;\n    display: none;\n    text-align: center;\n    font-size: 16px;\n    height: 40px;\n    margin: 0 auto 7px;\n}\n\n.custom-tab-box .store-address {\n    position: relative;\n}\n\n.custom-tab-box .store-address address {\n    max-width: 75%;\n    padding-top: 10px;\n    margin-bottom: 0;\n}\n\n.contact-info-list li a {\n    background: #c4161c;\n    color: #fff;\n    border-radius: 5px;\n    line-height: 30px;\n    padding: 0 5px;\n    margin-top: 20px;\n    display: inline-block;\n    width: 98px;\n}\n\n.catalog-banner {\n    margin-bottom: 7px;\n}\n\n.contact-info-list li a:focus,.contact-info-list li a:hover {\n    outline: none;\n    text-decoration: none;\n    color: #f26638;\n}\n\n.contact-info-list li a:hover i {\n    border: 1px solid #f26638;\n}\n\n.contact-info-list li a:hover .inventory-icon svg {\n    fill: #f26638;\n}\n\n.contact-info-list li small {\n    display: block;\n    text-align: center;\n    font-size: 11px;\n    text-transform: uppercase;\n    font-family: Merriweather Sans, sans-serif;\n}\n\n.contact-info-list li svg {\n    height: 33px;\n    margin-top: -4px;\n}\n\n.mobile-tab-view .nav-tabs::-webkit-scrollbar {\n    width: 10px;\n    border-radius: 5px;\n}\n\n.mobile-tab-view .nav-tabs::-webkit-scrollbar-track {\n    background: #495057;\n    border-radius: 5px;\n}\n\n.mobile-tab-view .nav-tabs::-webkit-scrollbar-thumb {\n    background: #c4161c;\n    border-radius: 5px;\n}\n\n.filter-box .checkmark:after {\n    left: 5px;\n    top: 1px;\n    width: 6px;\n    height: 10px;\n    border: solid #fff;\n    border-width: 0 2px 2px 0;\n    -webkit-transform: rotate(45deg);\n    transform: rotate(45deg);\n    content: \"\";\n    position: absolute;\n}\n\n.filter-container h3 {\n    font-size: 14px;\n    margin-bottom: 15px;\n    text-transform: uppercase;\n    font-weight: 700;\n}\n\n.filter-container {\n    border-bottom: 1px solid rgb(0,0,0,.09);\n    padding: 15px 0;\n}\n\n.search-inventory-page .product-slider .glassbox:hover {\n    box-shadow: 0 3px 16px 0 rgba(0,0,0,.11);\n}\n\n.grey-box {\n    padding: 10px;\n}\n\n.grey-box h2,.review h2,.store-inventory h2 {\n    color: #2e3a59;\n    font-size: 15px;\n    font-weight: 700;\n    margin-bottom: 15px;\n}\n\n.detail-search .store-inventory.storelocator-search input {\n    padding-left: 10px;\n    padding-right: 35px;\n    color: #8f9bb3;\n    font-size: 15px;\n    font-weight: 400;\n    border: 1px solid #e4e9f2;\n}\n\n.grey-box i {\n    margin-right: 5px;\n}\n\n.payment ul {\n    list-style: none;\n    padding: 0 0 0 4px;\n    margin-bottom: 0;\n}\n\n.payment ul li {\n    display: inline-block;\n    width: 48%;\n    margin-bottom: 15px;\n    color: #2e3a59;\n    font-size: 14px;\n    font-weight: 400;\n}\n\n.payment ul li i {\n    color: #c4161c;\n}\n\n.timing {\n    font-size: 13px;\n    color: #2e3a59;\n}\n\n.timing span {\n    font-weight: 400;\n}\n\n.store-detail-img img {\n    height: 220px;\n    object-fit: cover;\n    width: 100%;\n}\n\n.popular-product {\n    margin-top: 20px;\n    min-height: 500px;\n    position: relative;\n}\n\n.popular-product h3 {\n    font-size: 15px;\n    font-weight: 700;\n}\n\n.nearby-stores-content {\n    text-align: center;\n}\n\n.nearby-stores h2 {\n    margin-top: 30px;\n    border-radius: 5px;\n    background: #edf1f7;\n    padding: 14px 0;\n    font-size: 24px;\n    font-weight: 700;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.14;\n    letter-spacing: normal;\n    text-align: center;\n    color: #2e3a59;\n    text-transform: uppercase;\n}\n\n.nearby-stores-content ul {\n    padding: 0;\n    list-style: none;\n    display: flex;\n}\n\n.nearby-store-inner {\n    display: none;\n}\n\n.browse-online-cat {\n    margin-top: 30px;\n    font-size: 20px;\n    font-family: Merriweather Sans, sans-serif;\n    margin-bottom: 15px;\n}\n\nsection.display-grid {\n    display: grid;\n    grid-template-columns: repeat(2,1fr);\n    grid-gap: 15px;\n    margin-top: 15px;\n}\n\nsection.display-grid a {\n    box-shadow: 0 1px 5px #ddd;\n    background: #fff;\n    display: block;\n}\n\n.nearby-stores-content ul li {\n    margin-right: 30px;\n    position: relative;\n}\n\n.nearby-stores-content ul li:last-child {\n    margin-right: 0;\n}\n\n.nearby-stores-content ul li img {\n    border-radius: 5px;\n    height: 190px;\n    object-fit: cover;\n    width: 270px;\n}\n\n.store-description {\n    position: relative;\n}\n\n.viewallreview {\n    text-align: right;\n}\n\n.viewallreview a {\n    margin-top: 0;\n}\n\n.store-description {\n    border-radius: 8px;\n    background-blend-mode: multiply;\n    background-image: linear-gradient( to bottom,rgba(0,0,0,0) 3%,rgb(16,20,38) );\n    position: absolute;\n    height: 100%;\n    left: 0;\n    top: 0;\n    width: 100%;\n    content: \"\";\n}\n\n.store-description:hover {\n    background-image: linear-gradient( to bottom,rgba(0,0,0,0) -25%,rgb(16,20,38) );\n}\n\n.store-description span {\n    font-size: 14px;\n    font-weight: 600;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.43;\n    letter-spacing: normal;\n    position: absolute;\n    color: #fff;\n    bottom: 6px;\n    left: 15px;\n    right: 15px;\n    text-align: left;\n    padding-right: 30px;\n}\n\n.store-description span i {\n    position: absolute;\n    right: 0;\n    top: 21%;\n}\n\n.open-now {\n    background: #f7ca02;\n    border-radius: 2px;\n    font-size: 11px;\n    padding: 0 10px 2px;\n    display: inline-block;\n    color: #fff;\n    line-height: normal;\n    margin-left: 10px;\n}\n\n#map-content-view {\n    position: relative;\n}\n\n.view-map {\n    float: right;\n}\n\n#list-view {\n    background: #edf1f7;\n    min-height: 640px;\n}\n\n.list-view-sidebar {\n    margin-top: 20px;\n    margin-bottom: 20px;\n    height: 600px;\n    overflow-y: auto;\n}\n\n.store-banner {\n    position: relative;\n}\n\n.store-info {\n    margin-bottom: 15px;\n    box-shadow: 2px 2px 11px 0 #ccc;\n    border-radius: 5px;\n    padding-top: 1px;\n    background: #fff;\n}\n\n.rj-offer-desk {\n    margin-top: 30px;\n}\n\n.store-banner span {\n    position: absolute;\n    bottom: 10px;\n    color: #fff;\n    font-size: 12px;\n    font-family: Merriweather Sans, sans-serif;\n    font-weight: 700;\n    left: 15px;\n}\n\n.nearby-stores-content .row {\n    margin: 0;\n}\n\n.store-img {\n    position: relative;\n    background: #fff;\n    padding: 11px 0 28px;\n    border-radius: 5px 5px 0 0;\n    margin-bottom: 5px;\n    border-bottom: 1px solid #c4161c;\n}\n\n.store-img a {\n    display: block;\n    position: relative;\n}\n\n.book-appointment {\n    font-size: 12px;\n    letter-spacing: .5px;\n    font-weight: 400;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 40px;\n    text-align: center;\n    color: #fff;\n    display: block;\n    background: #f26522;\n    text-transform: uppercase;\n    margin-bottom: 15px;\n    border-radius: 5px;\n    margin-top: 10px;\n    text-decoration: none;\n}\n\n.book-appointment:hover {\n    background: #444;\n    color: #fff;\n    text-decoration: none;\n}\n\n.search-nearby-location {\n    padding: 0 15px;\n}\n\n.call-details a {\n    font-size: 11px;\n    color: #fff;\n    line-height: 40px;\n    display: inline-block;\n    border-radius: 5px;\n    padding: 0 3%;\n    width: 48%;\n    text-transform: uppercase;\n    text-align: center;\n    margin: 0;\n    text-decoration: none;\n    background: #c4161c;\n    font-weight: 400;\n    letter-spacing: .5px;\n}\n\n.call-details a:hover {\n    background: #444;\n}\n\na.redefining-width {\n    width: 49%!important;\n}\n\n.detail-search .call-details a {\n    width: 47%;\n    display: inline-block;\n    padding: 0;\n}\n\n.store-img img {\n    height: auto;\n    object-fit: cover;\n    width: 232px;\n    padding: 0 38px 0 25px;\n    margin: 0 auto;\n    display: block;\n}\n\n.store-details {\n    float: right;\n}\n\n.store-img a:before {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    content: \"\";\n    top: 0;\n    left: 0;\n}\n\n.store-img a:hover {\n    text-decoration: none;\n}\n\n.store-address {\n    padding: 10px 15px 1px;\n}\n\n#footer {\n    background: #505050;\n    color: #fff;\n    padding: 18px 0 5px;\n    color: #ccc;\n    overflow: hidden;\n    font-size: 13px;\n    font-family: Merriweather Sans, sans-serif;\n    font-weight: 300;\n}\n\n#footer a,#footer h4 {\n    color: #fff;\n    font-family: Merriweather Sans, sans-serif;\n}\n\n#footer h4 {\n    font-size: 16px;\n}\n\n#footer a:hover {\n    color: #1e8178;\n}\n\n.store-list {\n    padding-bottom: 20px;\n}\n\n.footer-bottom {\n    padding-top: 10px;\n    float: left;\n    width: 100%;\n    border-top: 1px solid #fff;\n}\n\n#footer .copyright {\n    text-transform: capitalize;\n    padding: 5px 0;\n    color: #fff;\n    font-size: 14px;\n    font-family: Merriweather Sans, sans-serif;\n    font-weight: 600;\n    margin: 0;\n}\n\n.detail-search .book-appointment-button a {\n    background: 0 0;\n    color: #2e3a59;\n    font-family: Merriweather Sans, sans-serif;\n    font-size: 14px;\n    width: auto;\n    margin: 0 0 0 9px;\n    text-transform: none;\n}\n\n.modal.and.carousel {\n    position: absolute;\n}\n\n.mobile-view {\n    display: none;\n}\n/* \n.carousel-control {\n    top: 45%;\n    width: 5%;\n    background-image: none;\n}\n\n.carousel-control.left,.carousel-control.right {\n    background-image: none;\n}\n\n.carousel-control.left {\n    margin-left: 25px;\n}\n\n.carousel-control.right {\n    margin-right: 25px;\n}\n\n.carousel.slide {\n    box-shadow: none;\n} */\n\n.store-inventory {\n    margin-top: 30px;\n}\n\n.nearby-stores {\n    margin-bottom: 25px;\n    margin-top: 30px;\n}\n\naddress strong {\n    padding-left: 5px;\n}\n\n.store-name span i {\n    float: right;\n    margin-top: 2px;\n}\n\n.detail-search .graphflexslider .flex-direction-nav .flex-prev {\n    left: auto;\n    top: 23px;\n    right: 19px;\n    height: 24px;\n    width: 18px;\n}\n\n.detail-search .graphflexslider .flex-direction-nav a:before {\n    font-size: 22px;\n}\n\n.detail-search .flex-direction-nav .flex-prev:before {\n    content: \"\\f053\";\n}\n\n.detail-search .graphflexslider .flex-direction-nav .flex-next {\n    top: 23px;\n    height: 24px;\n    right: 0;\n    width: 18px;\n}\n\n#day {\n    position: absolute;\n    z-index: 9;\n    font-family: Merriweather Sans, sans-serif;\n}\n\n.graphflexslider {\n    position: relative;\n    padding: 10px 0;\n}\n\n.detail-search .flex-direction-nav .flex-next {\n    right: 10px;\n    opacity: 1;\n    z-index: 1;\n}\n\n.detail-search .flex-direction-nav a.flex-next:before {\n    content: \"\\f054\";\n}\n\n.detail-search .graphflexslider .flex-direction-nav a:before {\n    font-size: 22px;\n}\n\n.detail-search .flex-direction-nav a:before {\n    font-family: FontAwesome;\n    color: #c4161c;\n}\n\n.detail-search .flex-direction-nav a:before {\n    font-family: FontAwesome;\n    color: #c4161c;\n}\n\n.locality-store {\n    display: inline-block;\n    margin-top: 13px;\n    margin-bottom: 5px;\n}\n\n.detail-search .locality-store {\n    display: flex;\n}\n\n.flash-message p i.flash-message-byk-icon {\n    display: inline-block;\n    width: 52px;\n    height: 40px;\n    margin-right: 5px;\n    vertical-align: middle;\n}\n\n.flash-message p a {\n    text-decoration: underline;\n    color: red;\n}\n\n.flash-message p a:hover {\n    text-decoration: none;\n}\n\n#mapOnSearch {\n    height: 100%;\n    width: 100%;\n}\n\n.detail-search .lenskart-gallery-slider {\n    overflow: hidden;\n    min-height: 500px;\n    position: relative;\n}\n\n.inventory-loading {\n    position: relative;\n}\n\na.browse-inventory.redefining-width.full-on-desktop.hideondesktop {\n    display: none;\n}\n\na.book-appointment.makeithideonscrolll.browse-inventory.redefining-width {\n    width: 100%!important;\n    font-size: 11px;\n}\n\n.loading:before,.inventory-loading:before {\n    display: block;\n    content: \"Loading Store Images\";\n    margin: auto;\n    text-align: center;\n    color: #505050;\n    font-size: 18px;\n    font-family: Merriweather Sans, sans-serif;\n    text-transform: uppercase;\n    position: absolute;\n    left: 0;\n    padding-top: 50px;\n    top: 0;\n    right: 0;\n    border: 1px solid #eee;\n    bottom: 0;\n    width: 100%;\n    height: 100%;\n    z-index: 1;\n}\n\n#map-content-view.loading:before {\n    content: \"\";\n    border: none;\n}\n\nspan.queue {\n    font-size: 12px;\n    text-transform: initial;\n}\n\n#map-content-view .location.loading:before {\n    content: \"\";\n    border: none;\n}\n\n.product-slider {\n    position: relative;\n    min-height: 500px;\n}\n\n.inventory-loading:before {\n    content: \"Loading Inventory Images\";\n    top: 50px;\n}\n\n.detail-search .lenskart-gallery-slider ul li img {\n    height: 360px;\n    object-fit: cover;\n    border-radius: 5px;\n}\n\n.detail-search .flexslider {\n    margin: 0 0 20px;\n}\n\n.detail-search #slider.flexslider {\n    border: 1px solid #eee;\n}\n\n.detail-search #carousel,.detail-search #carousel_1 {\n    border: 10px solid #edf1f7;\n    border-radius: 5px;\n    background: #edf1f7;\n}\n\n.detail-search #carousel img,.detail-search #carousel_1 img {\n    width: 100%;\n    margin: 0;\n    height: 180px;\n    object-fit: cover;\n    border-radius: 0;\n}\n\n.detail-search .flex-direction-nav .flex-next {\n    right: 10px;\n    opacity: 1;\n    z-index: 1;\n}\n\ndiv#book {\n    z-index: 99999;\n}\n\n.detail-search .flex-direction-nav a.flex-next:before {\n    content: \"\\f054\";\n}\n\n#listingTable .flex-direction-nav a.flex-next:before,.searchResult .flex-direction-nav .flex-next:before {\n    content: \"\\f054\";\n}\n\n#listingTable .flex-direction-nav a.flex-prev:before {\n    content: \"\\f053\";\n}\n\n#listingTable .flex-direction-nav a.flex-next,.searchResult .flex-direction-nav .flex-next {\n    right: -15px;\n    opacity: 1;\n}\n\n.searchResult .flex-direction-nav .flex-next,.searchResult .flexslider:hover .flex-direction-nav .flex-next {\n    right: 10px;\n    opacity: 1;\n}\n\n.searchResult .flexslider:hover .flex-direction-nav .flex-prev {\n    left: 10px;\n}\n\n.searchResult .flex-direction-nav .flex-prev {\n    left: 10px;\n    opacity: 1;\n}\n\n#listingTable .flex-direction-nav a.flex-prev {\n    left: -15px;\n    opacity: 1;\n}\n\n#google-reviews h2 a {\n    float: right;\n    width: auto;\n    margin: 0;\n    background: #ccc;\n    padding: 5px 10px;\n    font-size: 13px;\n    border-radius: 4px;\n}\n\n#listingTable .flex-direction-nav a:before {\n    font-family: FontAwesome;\n    color: #c4161c;\n}\n\ndiv#carouselnew {\n    margin: 0 auto;\n    max-width: 560px;\n}\n\n.detail-search .flex-direction-nav a:before,.searchResult .flex-direction-nav a:before {\n    font-family: FontAwesome;\n    color: #c4161c;\n}\n\n#image_store_carousel li {\n    border: 1px solid #ccc;\n    cursor: pointer;\n}\n\n#image_store_carousel li.flex-active-slide {\n    border: 1px solid #c4161c;\n}\n\ndiv#slidernew {\n    margin: 0 0 30px;\n}\n\n.detail-search .flex-direction-nav .flex-prev:before,.searchResult .flex-direction-nav .flex-prev:before {\n    content: \"\\f053\";\n}\n\n.detail-search .flex-direction-nav .flex-prev {\n    left: 10px;\n    opacity: 1;\n    z-index: 1;\n}\n\n.detail-search #carousel .slides li,.detail-search #carousel_1 .slides li {\n    position: relative;\n    cursor: pointer;\n}\n\n.flexslider:hover .flex-direction-nav .flex-prev {\n    opacity: .9;\n    left: -15px;\n}\n\n.flexslider:hover .flex-direction-nav .flex-next {\n    opacity: .9;\n    right: -15px;\n}\n\n.searchResult-product .product-data p {\n    font-size: 12px;\n    text-transform: uppercase;\n    padding: 0 10px;\n}\n\n.flexslider .slides>li {\n    border: 1px solid #eee;\n}\n\n.searchResult-product .searchbtn .btn {\n    margin: 20px 0 0!important;\n    padding: 7px;\n    font-size: 10px;\n}\n\n.searchResult.searchResult-product .container {\n    margin-left: 10%;\n    margin-right: 10%;\n    width: 80%;\n}\n\n.searchResult .flexslider {\n    margin: 0;\n    border: none;\n}\n\n.searchResult-product .product-data {\n    padding: 25px 0 12px;\n}\n\n.searchResult-product .product-image {\n    padding-top: 10px;\n    height: 75px;\n    display: table-cell;\n    text-align: center;\n    vertical-align: middle;\n    padding: 0 15px;\n}\n\n.searchResult.searchResult-product {\n    border: none;\n    padding: 0;\n    margin: 0 0 -25px;\n}\n\n.detail-search #carousel .slides li:before {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 15px;\n    bottom: 0;\n    text-align: center;\n    z-index: 9;\n    background: rgba(0,0,0,.4);\n    content: \"\";\n    width: 100%;\n    z-index: 0;\n    color: #fff;\n}\n\n.detail-search #carousel .slides li.flex-active-slide:before {\n    display: none;\n}\n\n.detail-search #carousel .slides li:hover:before {\n    display: block;\n}\n\n.store-detail-info h2 {\n    display: none;\n}\n\n.input-wrapper {\n    position: relative;\n}\n\n.clear {\n    border: 1px solid transparent;\n    background-color: transparent;\n    display: inline-block;\n    vertical-align: middle;\n    outline: 0;\n    cursor: pointer;\n    float: left;\n    margin: 14px 0 0 -28px;\n    cursor: pointer;\n}\n\n.clear:after {\n    content: \"X\";\n    display: block;\n    width: 20px;\n    height: 20px;\n    background-color: #4bb3a0;\n    z-index: 1;\n    font-family: Merriweather Sans, sans-serif;\n    margin: auto;\n    padding: 2px;\n    border-radius: 50%;\n    text-align: center;\n    color: #fff;\n    font-weight: 400;\n    font-size: 15px;\n    cursor: pointer;\n}\n\n#pac-input:not(:valid)~.clear {\n    display: none;\n}\n\n#pac-input-for-search:not(:valid)~.clear {\n    display: none;\n}\n\n#pac-input-for-search {\n    height: 48px;\n}\n\n#pac-input:valid~.gps-location {\n    display: none;\n}\n\n#mapFull {\n    height: 100%;\n    width: 100%;\n}\n\n#storetitle span {\n    display: block;\n    margin-bottom: 10px;\n    font-size: 14px;\n    color: #333;\n    font-family: Merriweather Sans, sans-serif;\n}\n\n#storetitle {\n    width: 250px;\n}\n\n#storetitle span:first-child {\n    padding: 10px;\n    background: #f7f7f7;\n    margin-top: 10px;\n    font-size: 15px;\n    color: #373737;\n    font-weight: 600;\n}\n\n#storetitle .store-call-detail span:first-child {\n    background: 0 0;\n    padding: 0;\n}\n\n#storetitle .store-call-detail span:first-child a {\n    float: right;\n    background: #ed1b24;\n    padding: 3px 15px;\n    color: #fff;\n    margin-top: -3px;\n    font-weight: 400;\n}\n\n#storetitle span a:hover,#storetitle .store-call-detail span:first-child a:hover {\n    text-decoration: none;\n    background: #444;\n}\n\n#search-nearby-tab p {\n    text-align: left;\n}\n\n.map-store-details a {\n    display: inline-flex;\n    background: #04428f;\n    font-size: 13px;\n    text-transform: uppercase;\n    padding: 0;\n    width: 120px;\n    text-align: center;\n    height: 26px;\n    align-items: center;\n    justify-content: center;\n    margin-left: 1px;\n    color: #fff;\n}\n\n.map-store-details a:last-child {\n    background: #1e8178;\n    color: #fff;\n    float: right;\n}\n\n#storetitle span.map-store-details {\n    margin-bottom: 0;\n}\n\n#mapFullScreen {\n    height: 750px;\n}\n\n.thischeck {\n    background: #f36523;\n}\n\n.product-slider .glassbox {\n    border: #ebebeb solid 1px;\n    padding: 10px;\n    margin-bottom: 15px;\n    border-radius: 5px;\n    cursor: pointer;\n}\n\n.product-slider .glassbox span {\n    font-weight: 400;\n    display: block;\n    line-height: normal;\n}\n\n.thankyou img {\n    max-width: 100px;\n}\n\n.thankyou .inner-wrapper {\n    border: 2px solid #000;\n    border-radius: 3px;\n    max-width: 480px;\n    margin: 0 auto;\n    padding: 40px 40px 0;\n}\n\np.success-msg {\n    font-size: 22px;\n    color: #505050;\n    text-transform: uppercase;\n    text-align: center;\n    font-family: futurabt-book;\n}\n\n.thankyou span {\n    display: block;\n}\n\n.modal-content .modal-body.thankyou {\n    padding: 3rem 4rem;\n    text-align: center;\n}\n\n#successModal button.btn-close {\n    background: #000;\n    color: #fff;\n    width: 100%;\n    border: 0;\n    max-width: 200px;\n    padding: 10px;\n    position: relative;\n    top: 20px;\n    font-size: 15px;\n    text-transform: uppercase;\n    font-family: Merriweather Sans, sans-serif;\n    cursor: pointer;\n}\n\n.cm-details p.address {\n    font-size: 16px;\n    color: #505050;\n    font-family: Merriweather Sans, sans-serif;\n}\n\n.cm-details p.time-slot-book {\n    font-family: Merriweather Sans, sans-serif;;\n    font-size: 22px;\n    color: #505050;\n    line-height: normal;\n    margin-bottom: 25px!important;\n}\n\n.site-map {\n    padding: 0;\n}\n\n.site-map h3 {\n    font-size: 24px;\n    font-weight: 500;\n}\n\n.site-map h4 {\n    font-size: 20px;\n}\n\n.site-map li.site-map-city {\n    list-style: disc;\n    padding: 25px 10px 5px 5px;\n    margin-left: 29px;\n}\n\n.site-map li.site-map-state {\n    list-style: none;\n    padding: 0 0 5px 0;\n    border-bottom: 2px solid #eee;\n}\n\n.site-map li.site-map-locality {\n    list-style: circle;\n    margin: 0 10px 6px 43px;\n}\n\n.site-map li.site-map-locality a {\n    color: #c4161c;\n}\n\n.site-map-head {\n    margin: 50px 0;\n}\n\na.browse-inventory {\n    font-size: 12px;\n    color: #fff;\n    line-height: 40px;\n    display: inline-block;\n    border-radius: 5px;\n    width: 100%;\n    text-transform: uppercase;\n    text-align: center;\n    margin: 8px 0 0;\n    text-decoration: none;\n    background: #f26638;\n    font-weight: 400;\n    letter-spacing: .5px;\n    padding: 0% 3%;\n    display: none;\n}\n\n.rj-offer-desk.showthis.home {\n    display: none;\n}\n\n.rj-offer-desk.showthis {\n    display: none;\n}\n\nimg.img-responsive.small-banner {\n    height: 10em;\n    width: 100%;\n    padding-bottom: 15px;\n    padding-left: 15px;\n    padding-right: 15px;\n    display: none;\n}\n\na.tel.b {\n    width: 100%;\n}\n\n.call-details.review {\n    padding-bottom: 15px;\n}\n\na.tel-mobile {\n    float: right;\n    margin: 8px 0 0;\n}\n\nbutton.close {\n    z-index: 1;\n    position: relative;\n}\n\ndiv.searchbox.inventory {\n    position: relative;\n}\n\nspan.search-icon-mobile {\n    float: right;\n    margin: 14px 23px 0 0;\n}\n\n#search-nearby input.form-control.searchinv,.detail-search .storelocator-search input {\n    height: 30px;\n    width: 430px;\n}\n\nbutton#searchinvbtn img {\n    height: 15px;\n    width: 15px;\n    cursor: pointer;\n}\n\n.searchResult {\n    margin: 0 15px 30px;\n    border: 1px solid rgb(235,229,229,.6);\n    padding: 20px;\n    border-radius: 5px;\n}\n\n.product-data p {\n    font-size: 24px;\n    line-height: normal;\n}\n\n.searchbtn .btn {\n    margin: 20px 0 0!important;\n    padding: 10px 20px;\n    font-size: .8em;\n}\n\n.searchResult .product-price {\n    color: #4bb3a0;\n}\n\nbutton#searchinvbtn {\n    position: relative;\n    right: 10px;\n    border-radius: 0 4px 4px 0;\n}\n\n#appendInventorySearch.loading:before {\n    content: \"\";\n}\n\n#footer .nav-flex-icons li {\n    display: inline-block;\n    padding: 0 8px;\n}\n\n#footer .nav-flex-icons {\n    text-align: center;\n}\n\n#appendInventorySearch button.book-appointment.static-show.btn.btn-mdb-color.btn-rounded.btn-sm.my-0.ml-sm-2.waves-effect.waves-light {\n    line-height: normal;\n    padding: 10px 15px;\n}\n\np.product-desc {\n    font-size: 14px;\n    line-height: 1.8em;\n    text-transform: capitalize;\n}\n\nimg.gps-location {\n    position: absolute;\n    right: 25px;\n    top: 15px;\n    cursor: pointer;\n}\n\n#search-nearby-tab #pac-input,.searchinv,.search-box-inventroy input,.search-product input,#pac-input-for-search,#search-switch-tab #pac-input {\n    width: 100%;\n    font-size: 15px;\n    font-weight: 400;\n    font-stretch: normal;\n    font-style: normal;\n    line-height: 1.33;\n    letter-spacing: normal;\n    color: #8f9bb3;\n    height: 48px;\n    border-radius: 4px;\n    border: solid 1px #e4e9f2;\n    background-color: #f7f9fc;\n    float: left;\n    padding-right: 35px;\n}\n\n#pac-input-for-search:valid~.gps-location {\n    display: none;\n}\n\n.search-product input {\n    float: none;\n    padding: 0 10px;\n    height: 38px;\n}\n\n.search-product {\n    padding: 11px 15px 14px;\n}\n\n.search-box-inventroy input {\n    height: 30px;\n    width: 100%;\n    border: none;\n    padding-left: 10px;\n    border-radius: 0;\n}\n\na#nextbrand,a#nextshape,a#nextstore {\n    cursor: pointer;\n    position: relative;\n    top: 5px;\n    text-decoration: underline;\n    color: #505050;\n}\n\n.search-box-inventroy .btn {\n    width: 30px;\n    height: 30px;\n    margin: 0 0 0 -7px;\n    border-radius: 0;\n    border: none;\n    padding: 0;\n}\n\n.booknsearch button.btn.searchbtn {\n    float: right;\n    font-size: .65em;\n    border-radius: 0;\n    padding: 4px;\n    font-weight: 700;\n}\n\n.booknsearch .pricebold {\n    float: left;\n}\n\n.booknsearch {\n    overflow: hidden;\n    margin-bottom: 10px;\n}\n\n.product-detail-search {\n    overflow: hidden;\n    margin: 0 0 20px;\n}\n\np.text-center.no-result-found {\n    font-size: 1.75em;\n    padding: 5% 0%;\n}\n\na.searchinventory.book-appointment.static-show {\n    margin: 11px -11px -11px;\n    border: none;\n    border-radius: 0;\n    background-color: #208178;\n}\n\na.tel-mobile,.search-icon-mobile {\n    display: none;\n}\n\nspan.tittle {\n    font-size: 1em;\n}\n\nspan.productprice {\n    font-size: 10px;\n    margin: 0!important;\n}\n\nspan.item-price {\n    font-size: 1em;\n    padding: 0!important;\n    margin: 0!important;\n}\n\nspan.sizeproduct {\n    margin-top: 0!important;\n    padding-top: 10px;\n    font-size: 10px;\n}\n\nspan.sizeproduct {\n    padding-top: 0;\n}\n\nspan.pricebold {\n    font-weight: 700!important;\n}\n\np.pricebold {\n    display: -webkit-inline-box;\n}\n\nspan.item-price {\n    padding-left: 4%!important;\n}\n\np.pricebold {\n    font-weight: 700!important;\n    margin-bottom: 0;\n}\n\nspan.genderimg {\n    position: absolute;\n    right: 10%;\n    top: 60%;\n}\n\nspan.showimgsicon {\n    position: absolute;\n    right: 10%;\n    top: 45%;\n}\n\na.removemargintop.book-appointment.static-show {\n    margin: 0;\n}\n\n.glassbox:hover a.removemargintop.book-appointment.static-show {\n    margin-top: 20px;\n}\n\n.product-detail-search {\n    overflow: hidden;\n    margin: 0 0 20px;\n}\n\n.product-detail-search .product-name {\n    float: left;\n}\n\n.product-detail-search .product-size {\n    float: right;\n    margin: 5px 0 0;\n}\n\n.near-search-store {\n    font-size: 12px;\n}\n\n.product-slider .near-search-store span {\n    float: right;\n    font-weight: 700;\n}\n\np.gst-included-price {\n    height: 32px;\n    background-color: #208178;\n    color: #fff;\n    text-align: center;\n    padding: 7px 0;\n    font-size: 14px;\n    font-weight: 500;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n}\n\n .carousel {\n    margin-left: 50px;\n}\n/*\n.carousel-inner img {\n    width: 100%;\n    height: 100%;\n}\n\n.carousel-indicators {\n    display: inline-block;\n    height: 300px;\n    overflow-y: scroll;\n    overflow-x: hidden;\n    position: static;\n    direction: rtl;\n}  */\n\n@media screen and (max-width:992px) {\n    .carousel-indicators {\n        display: inline-flex;\n        direction: inherit;\n        height: auto;\n        width: 100%;\n        max-width: 800px;\n        overflow-x: auto;\n        position: relative;\n        margin-left: 0;\n        margin-right: 0;\n        overflow-y: hidden;\n        justify-content: normal;\n        margin-bottom: 20px;\n    }\n\n    .carousel-inner {\n        margin-left: 0!important;\n    }\n}\n\n::-webkit-scrollbar {\n    width: 5px;\n    height: 5px;\n}\n\n::-webkit-scrollbar-track {\n    background: #f1f1f1;\n}\n\n::-webkit-scrollbar-thumb {\n    background: #888;\n}\n\n::-webkit-scrollbar-thumb:hover {\n    background: #555;\n}\n\n.item {\n    margin-bottom: 10px;\n    margin-left: 10px;\n    cursor: pointer;\n}\n\n.item.active img {\n    border: 1px solid red;\n    opacity: 1;\n}\n\n.item img {\n    border: 1px solid transparent;\n    opacity: .5;\n    transition: .5s;\n}\n\n.item:hover img {\n    border: 1px solid red;\n    opacity: 1;\n}\n\n.content {\n    position: absolute;\n    bottom: 0;\n    background: rgba(0,0,0,.5);\n    color: #f1f1f1;\n    width: 100%;\n    padding: 10px;\n}\n\n.content p {\n    font-size: 15px;\n}\n\n.new-popup-form .day-block,.new-popup-form .day-block:hover,.new-popup-form .day-block.active {\n    background: 0 0;\n}\n\n.new-popup-form .day-block.active .slot-date {\n    color: #4bb3a0;\n}\n\n.new-popup-form .day-block .slot-date {\n    width: 40px;\n    margin-bottom: 20px;\n    font-weight: 400;\n}\n\n.new-popup-form .day-block .slot-time {\n    font-weight: 700;\n    width: 40px;\n    height: 40px;\n    display: table-cell;\n    vertical-align: middle;\n}\n\n.new-popup-form .day-block.active .slot-time {\n    background: #4bb3a0;\n    border-radius: 50%;\n    color: #fff;\n}\n\n.new-popup-form .day-block {\n    color: #505050;\n    font-size: 16px;\n}\n\n.new-popup-form .select-day-time {\n    border: none;\n    padding-left: 0;\n    padding-right: 0;\n}\n\n.new-popup-form .time-slot-field-wrapper {\n    background: #f3f4f8;\n    margin: 0 -16px;\n    padding: 15px;\n    -webkit-box-shadow: inset 0 5px 10px 1px #c2c5cc;\n    box-shadow: inset 0 5px 10px 1px #c2c5cc;\n}\n\n.new-popup-form .time-slot {\n    background: #fff;\n    margin-bottom: 10px;\n    margin-top: 10px;\n    box-shadow: 0 0 3px #333;\n    margin-right: 17px;\n    border: 2px solid transparent;\n    padding: 10px 0;\n}\n\n.new-popup-form .time-slot-field {\n    text-align: left;\n}\n\n.new-popup-form .disabled {\n    background: #e8e9ed;\n    color: #b5b6ba;\n}\n\n.new-popup-form .time-slot-field .slot-all {\n    margin-top: 20px;\n    text-align: center;\n}\n\n.new-popup-form .optional {\n    margin-top: 10px;\n}\n\n.new-popup-form .row.select-slots {\n    padding: 0 0 20px;\n    display: block;\n}\n\n.new-popup-form .row.select-slots {\n    border-top: 1px solid #e4e9f2;\n    padding-top: 15px;\n    padding-bottom: 15px;\n}\n\n.new-popup-form .row.select-slots span {\n    border: 1px solid #e4e9f2;\n    border-radius: 5px;\n    display: inline-block;\n    padding: 10px 20px;\n}\n\n.new-popup-form .row.select-slots span.active {\n    background: #4bb3a0;\n    border: 1px solid #e4e9f2;\n    color: #fff;\n}\n\n.new-popup-form .day-block,.new-popup-form .day-block:hover,.new-popup-form .day-block.active {\n    background: 0 0;\n}\n\n.new-popup-form .day-block.active .slot-date {\n    color: #4bb3a0;\n}\n\n.new-popup-form .day-block .slot-date {\n    width: 40px;\n    margin-bottom: 20px;\n    font-weight: 400;\n}\n\n.new-popup-form .day-block .slot-time {\n    font-weight: 700;\n    width: 40px;\n    height: 40px;\n    display: table-cell;\n    vertical-align: middle;\n}\n\n.new-popup-form .day-block.active .slot-time {\n    background: #4bb3a0;\n    border-radius: 50%;\n    color: #fff;\n}\n\n.new-popup-form .day-block {\n    color: #505050;\n    font-size: 16px;\n}\n\n.new-popup-form .select-day-time {\n    border: none;\n    padding-left: 0;\n    padding-right: 0;\n}\n\n.new-popup-form .time-slot-field-wrapper {\n    background: #f3f4f8;\n    margin: 0 -16px;\n    padding: 15px;\n    -webkit-box-shadow: inset 0 5px 10px 1px #c2c5cc;\n    box-shadow: inset 0 5px 10px 1px #c2c5cc;\n}\n\n.new-popup-form .time-slot {\n    background: #fff;\n    margin-bottom: 10px;\n    margin-top: 10px;\n    box-shadow: 0 0 3px #333;\n    margin-right: 17px;\n    border: 2px solid transparent;\n    padding: 10px 0;\n}\n\n.new-popup-form .time-slot-field {\n    text-align: left;\n}\n\n.new-popup-form .disabled {\n    background: #e8e9ed;\n    color: #b5b6ba;\n}\n\n.new-popup-form .time-slot-field .slot-all {\n    margin-top: 20px;\n    text-align: center;\n    font-weight: bolder;\n    font-size: 9px;\n    left: 5px;\n    position: relative;\n}\n\n.new-popup-form .optional {\n    margin-top: 10px;\n}\n\n.new-popup-form .row.select-slots {\n    padding: 0 0 20px;\n    display: block;\n}\n\n.new-popup-form .row.select-slots {\n    border-top: 1px solid #e4e9f2;\n    padding-top: 15px;\n    padding-bottom: 15px;\n}\n\n.new-popup-form .row.select-slots span {\n    border: 1px solid #707070;\n    border-radius: 5px;\n    display: inline-block;\n    cursor: pointer;\n    text-transform: capitalize;\n    font-weight: revert;\n}\n\n.new-popup-form .row.select-slots span.active {\n    background: #4bb3a0;\n    border: 1px solid #e4e9f2;\n    color: #fff;\n}\n\n@media screen and (max-width:992px) {\n    .content {\n        position: static;\n    }\n\n    .new-popup-form .time-slot {\n        margin-right: 10px;\n    }\n}\n\n@media screen and (min-width:1440px) {\n    .carousel-inner {\n        margin-left: -60px;\n    }\n\n    #corona-notif img {\n        margin: 0 100px!important;\n    }\n}\n\n@media screen and (min-width:1200px) and (max-width:1439px) {\n    .carousel-inner {\n        margin-left: -20px;\n    }\n\n    #corona-notif img {\n        margin: 0 100px!important;\n    }\n}\n\n@media screen and (min-width:880px) and (max-width:1199px) {\n    .carousel-inner {\n        margin-left: 20px;\n    }\n\n    .content {\n        position: static;\n    }\n\n    #corona-notif img {\n        margin: 0 100px!important;\n    }\n}\n\n@media screen and (min-width:576px) and (max-width:879px) {\n    .carousel-inner {\n        margin-left: 50px;\n    }\n\n    .content {\n        position: static;\n    }\n}\n\n.vert .carousel-item-next.carousel-item-left,.vert .carousel-item-prev.carousel-item-right {\n    -webkit-transform: translate3d(0,0,0);\n    transform: translate3d(0,0,0);\n}\n\n.vert .carousel-item-next,.vert .active.carousel-item-right {\n    -webkit-transform: translate3d(0,100%,0);\n    transform: translate3d(0,100% 0);\n}\n\n.vert .carousel-item-prev,.vert .active.carousel-item-left {\n    -webkit-transform: translate3d(0,-100%,0);\n    transform: translate3d(0,-100%,0);\n}\n\nh1.no-inventory-found {\n    font-size: 3em!important;\n    color: #444;\n    text-align: center!important;\n    padding: 3%;\n}\n\nh1.no-inventory-found {\n    font-size: 2em!important;\n    padding: 5% 9%;\n}\n\nspan.closed {\n    color: #ec0a0a!important;\n}\n\ndiv.disabled-till-date-check {\n    background: #e8e9ed;\n}\n\n.inner-tab-box {\n    text-align: right;\n    padding-bottom: 25px;\n    padding-top: 10px;\n}\n\n#search-switch-tab p {\n    text-align: left;\n    padding-top: 30px;\n    clear: both;\n}\n\n.inner-tab-box .inner-tab-title {\n    width: 100%;\n}\n\n.store-locator .custom-tab-box ul li a,.store-locator .custom-tab-box ul li a.active {\n    border: none;\n}\n\n.store-locator .custom-tab-box ul li a.active {\n    background-color: #39bcd3;\n    border-radius: 30px;\n}\n\n.store-locator .custom-tab-box ul li a {\n    width: 15px;\n    height: 15px;\n    display: inline-block;\n}\n\n.store-locator .custom-tab-box ul {\n    display: flex;\n    background: rgb(31 47 70);\n    transition: all .7s linear;\n    border-radius: 30px;\n    margin-left: 20px;\n    padding: 4px 4px 1px;\n    margin-bottom: 0;\n    margin-top: -3px;\n    width: 39px;\n    float: right;\n}\n\n.store-locator .custom-tab-box ul li.advance-tab {\n    line-height: 36px;\n    margin-right: 30px;\n}\n\n.custom-tab-box {\n    padding-top: 6px;\n}\n\n#content.detail-search .mobile-tab-view #tabsJustifiedContent {\n    text-align: left;\n}\n\n.mobile-tab-view .nav-tabs {\n    border: none;\n    flex-wrap: nowrap;\n    display: flex;\n    overflow-y: auto;\n    padding-bottom: 10px;\n    margin-top: 20px;\n    margin-bottom: 10px;\n}\n\n.mobile-tab-view .nav-tabs li {\n    padding: 0 18px 0 0;\n}\n\n.mobile-tab-view iframe {\n    height: 220px!important;\n}\n\n.mobile-tab-view .rj-offer-desk,.mobile-tab-view #google-reviews,.mobile-tab-view .popular-product {\n    margin-top: 0;\n}\n\n.mobile-tab-view .nav-tabs .nav-link {\n    border: none;\n    color: #495057;\n    border-bottom: 2px solid transparent;\n    padding: 5px 0;\n    width: max-content;\n    font-size: 16px;\n    font-family: Merriweather Sans, sans-serif;\n    font-weight: 600;\n}\n\n.mobile-tab-view .nav-tabs .nav-link.active {\n    border-bottom: 2px solid #f26638;\n}\n\n.mobile-tab-view {\n    display: none;\n}\n\n.mobile-tab-view .fixed-call a {\n    position: static!important;\n    border-radius: 5px!important;\n}\n\n.call-details.fixed-call {\n    margin-top: 13px;\n}\n\n.search-box-wrapper {\n    background: #edf1f7;\n    padding: 15px;\n    min-height: 362px;\n    border-radius: 5px;\n}\n\n.main-home .store-locator {\n    margin-top: 0;\n}\n\n.store-locator .custom-tab-box ul li {\n    padding: 0;\n    margin-bottom: 0;\n}\n\n.flickity-page-dots {\n    display: none;\n}\n\n.spacing-with-padding {\n    margin-bottom: 10px;\n}\n\n.carousel-cell {\n    width: 100%;\n    height: 362px;\n    margin-right: 10px;\n    border-radius: 5px;\n}\n\n.flickity-enabled.is-draggable {\n    margin-top: 0;\n}\n\n.slider-with-tab .col-md-8 {\n    float: right;\n}\n\n.home-page-container {\n    width: 100%;\n}\n\n@media all and (max-width:1024px) {\n    #search-nearby input.form-control.searchinv,.detail-search .storelocator-search input {\n        height: 30px;\n        width: 100%;\n    }\n\n    div.searchbox.inventory {\n        position: relative;\n        display: flex;\n    }\n\n    .sticky .nav-flex-icons {\n        display: none;\n    }\n\n    button#searchinvbtn {\n        margin-left: -5px!important;\n        right: 0;\n        width: 50px;\n    }\n\n    #header ul.nav-flex-icons li {\n        font-size: 18px;\n        text-align: center;\n    }\n\n    #free-eyecheckup {\n        display: none;\n    }\n\n    .nav-flex-icons {\n        padding-top: 11px;\n        display: flex;\n        text-align: center;\n        padding-bottom: 10px;\n    }\n\n    .mobile-view {\n        display: block;\n    }\n\n    #header .desktop-view {\n        display: none!important;\n    }\n\n    a.tel-mobile,span.search-icon-mobile {\n        display: none;\n    }\n\n    .call-details a {\n        font-size: 11px;\n        padding: 0 13%;\n    }\n\n    .list-view-sidebar {\n        height: 400px;\n    }\n\n    iframe {\n        height: 420px!important;\n    }\n\n    #list-view {\n        min-height: 450px;\n    }\n}\n\n@media all and (max-width:1023px) and (min-width:768px) {\n    .store-locator #tabsJustified li a {\n        padding: 0 16px;\n        font-size: 12px;\n    }\n\n    .detail-search .tel span {\n        margin-left: 15px;\n    }\n\n    .inner-tab-box {\n        display: block;\n        overflow: hidden;\n    }\n\n    .search-box-wrapper {\n        min-height: 340px;\n        padding-bottom: 0;\n    }\n\n    #tabsJustifiedContent .dropdown .dropdown-toggle,#tabsJustifiedContent .btn,#search-nearby-tab #pac-input,.searchinv,.search-box-inventroy input,#advanced-search .dropdown .btn {\n        height: 34px;\n    }\n\n    .store-locator .custom-tab-box ul {\n        width: 39px;\n        float: right;\n        margin-top: 8px;\n    }\n\n    .inner-tab-box .inner-tab-title {\n        float: left;\n    }\n\n    span.advance-tab {\n        margin-top: 12px;\n        float: left;\n    }\n\n    .carousel-cell {\n        height: 340px;\n    }\n\n    .carousel-cell img {\n        width: 100%;\n    }\n}\n\n@media all and (max-width:1024px) and (min-width:768px) {\n    .loc-pin {\n        max-width: 18px!important;\n        margin-right: 10px;\n        height: auto;\n    }\n\n    .search-nearby-location {\n        padding: 0 15px;\n        display: flex;\n    }\n\n    .call-details a {\n        font-size: 10px;\n        float: none;\n        padding: 0 5%;\n        margin-bottom: 15px;\n        display: block;\n        width: auto;\n    }\n\n    .detail-search .call-details a {\n        width: 100%!important;\n    }\n}\n\n@media all and (max-width:767px) {\n    a.tel.redefining-width.r-d-cta-w {\n        font-size: 10px;\n    }\n\n    a.store-details.r-d-cta-w {\n        font-size: 10px!important;\n    }\n\n    .speak-experts.store-info.new-button-cta {\n        margin-top: 20px;\n    }\n\n    a.r-d-cta-w {\n        width: 100%!important;\n        text-align: center;\n        box-shadow: 0 10px 6px -6px rgba(0,0,0,.2);\n        transition: all ease-in-out 300ms;\n        font-size: 12px!important;\n        line-height: 25px;\n        padding: 0!important;\n        border-radius: 5px;\n        margin: 15px 0;\n    }\n\n    a.book-appointment.makeithideonscrolll.browse-inventory.redefining-width {\n        transition: all .3s ease 0s;\n        box-shadow: 0 15px 20px rgba(46,229,157,.4);\n    }\n\n    .slider-with-tab .flickity-enabled.is-draggable {\n        margin-bottom: 15px;\n    }\n\n    .rj-offer-desk.showthis {\n        display: none;\n    }\n\n    body #content.detail-search h1 {\n        font-size: 20px;\n        margin-top: 10px;\n    }\n\n    .rj-offer-desk.showthis {\n        display: none!important;\n    }\n\n    .nearby-stores h2 {\n        margin-top: 10px;\n        font-size: 20px;\n    }\n\n    #search-nearby-tab p {\n        display: none;\n    }\n\n    .spacing-with-padding {\n        margin-bottom: 23px;\n    }\n\n    a#whatsappimage {\n        left: 15px;\n        right: 15px;\n        background: 0 0;\n        bottom: 7px;\n        z-index: 9;\n    }\n\n    #scroll {\n        bottom: 10px;\n    }\n\n    .flickity-page-dots {\n        display: block;\n        position: absolute;\n        bottom: 5px;\n    }\n\n    .flickity-page-dots .dot {\n        background: #fff;\n        opacity: 1;\n        margin: 0 5px;\n    }\n\n    .detail-search #carousel {\n        margin-bottom: 0;\n    }\n\n    .nearby-stores {\n        margin-top: 0;\n    }\n\n    .detail-search .lenskart-gallery-slider {\n        min-height: 0;\n    }\n\n    .detail-search .lenskart-gallery-slider ul li img {\n        height: 260px;\n    }\n\n    .detail-search #carousel img {\n        height: 135px;\n    }\n\n    #tabsJustifiedContent .dropdown .dropdown-toggle {\n        height: 48px;\n    }\n\n    #search-switch-tab p {\n        text-align: center;\n    }\n\n    #search-switch-tab .btn {\n        margin-top: 0!important;\n    }\n\n    .flickity-page-dots .dot.is-selected {\n        background: #c4161c;\n    }\n\n    .flickity-prev-next-button.previous,.flickity-prev-next-button.next {\n        display: none;\n    }\n\n    .search-box-wrapper {\n        min-height: 0;\n    }\n\n    .slider-with-tab .col-md-8 {\n        float: none;\n        display: none;\n    }\n\n    #tabsJustifiedContent .dropdown .dropdown-toggle {\n        margin-top: 0;\n    }\n\n    .carousel-cell {\n        height: 120px;\n    }\n\n    .carousel-cell img {\n        width: 100%;\n    }\n\n    .mobile-tab-view {\n        display: block;\n    }\n\n    .sidebar-desktop {\n        display: none;\n    }\n\n    .mobile-tab-view .col-md-12 {\n        padding: 0;\n    }\n\n    .new-popup-form .time-slot-field .col-md-3 {\n        -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n        max-width: 25%;\n        padding-right: 0;\n        padding-left: 0;\n    }\n\n    .new-popup-form .time-slot-field .col-md-9 {\n        -ms-flex: 0 0 75%;\n        flex: 0 0 75%;\n        max-width: 75%;\n        padding-right: 0;\n        margin-bottom: 8%;\n    }\n\n    .new-popup-form .time-slot {\n        margin: 0 9px 25px;\n        width: 25%;\n    }\n\n    .new-popup-form .day-group label {\n        margin-bottom: 10px;\n    }\n\n    .new-popup-form .select-day-time {\n        padding-top: 5px;\n    }\n\n    .new-popup-form .time-slot-field {\n        text-align: left;\n        margin: 18px 0;\n    }\n\n    .new-popup-form .submitBtnLead {\n        margin-top: 0;\n    }\n\n    .new-popup-form .time-slot-field:last-child {\n        text-align: left;\n        margin: 18px 0 0;\n    }\n\n    .new-popup-form .row.select-slots span {\n        padding: 10px 15px;\n        font-size: 12px;\n    }\n\n    .new-popup-form .row.select-slots .col-md-6 {\n        width: auto;\n        padding: 0 10px;\n    }\n\n    .new-popup-form .optional input {\n        width: 100%;\n    }\n\n    .store-address address .locality-store i {\n        margin-top: -5px;\n    }\n\n    .locality-store {\n        display: flex;\n    }\n\n    span.operational-time {\n        display: flex;\n    }\n\n    span.sizeproduct {\n        padding-bottom: 5%;\n    }\n\n    span.tittle {\n        padding-top: 5%;\n    }\n\n    span.sizeproduct {\n        position: absolute;\n        right: 10%;\n        top: 188px;\n    }\n\n    span.genderimg {\n        position: absolute;\n        right: 10%;\n        top: 230px;\n    }\n\n    span.sizeproduct.gender {\n        top: 200px;\n    }\n\n    span.sizeproduct {\n        color: #444;\n    }\n\n    a.book-appointment.static-show {\n        margin-top: 3%;\n    }\n\n    span.showimgsicon {\n        position: absolute;\n        right: 10%;\n        top: 70%;\n    }\n\n    a.tel-mobile,span.search-icon-mobile {\n        display: block;\n    }\n\n    div.searchbox.inventory {\n        position: relative;\n        display: flex;\n    }\n\n    .sticky .nav-flex-icons {\n        display: none;\n    }\n\n    button#searchinvbtn {\n        margin-left: -5px!important;\n        right: 0;\n        width: 50px;\n    }\n\n    #header ul.nav-flex-icons li {\n        font-size: 18px;\n        text-align: center;\n        width: 100%;\n    }\n\n    .nav-flex-icons {\n        padding-top: 5px;\n        width: 100%;\n        display: flex;\n        text-align: center;\n        padding-bottom: 10px;\n    }\n\n    .mobile-view {\n        display: block;\n    }\n\n    #header .desktop-view {\n        display: none;\n    }\n\n    #listingTable .flex-direction-nav a:before {\n        font-size: 30px;\n    }\n\n    #search-nearby input.form-control.searchinv {\n        width: 100%;\n        background: #f7f9fc;\n        height: 40px;\n    }\n\n    .sticky a.tel-mobile {\n        display: block;\n    }\n\n    .rj-offer-desk.showthis {\n        margin: 10px 0 0;\n        padding-bottom: 15px;\n        display: block;\n    }\n\n    .rj-offer-desk.showthis.home {\n        display: block;\n    }\n\n    .rj-offer-desk.showthis.home {\n        margin: 0 0 -25px 0;\n    }\n\n    #content h1 {\n        font-size: 0;\n    }\n\n    img.img-responsive.small-banner {\n        display: block;\n    }\n\n    a.browse-inventory {\n        display: block;\n    }\n\n    main#content {\n        margin-top: 15px;\n    }\n\n    a.book-appointment.static-show {\n        position: static;\n    }\n\n    .detail-search .store-address a.book-appointment {\n        z-index: 999;\n    }\n\n    a.book-appointment.makeithideonscrolll.browse-inventory.redefining-width {\n        width: 100%!important;\n    }\n\n    .pagination {\n        display: block;\n    }\n\n    .pagination li {\n        display: inline-block;\n        margin-top: 5px;\n    }\n\n    .list-map-view,.view-map {\n        display: none;\n    }\n\n    .detail-search .book-appointment {\n        position: fixed;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        margin: 0 0;\n        border-radius: 0;\n        z-index: 99;\n    }\n\n    .detail-search.stick .book-appointment {\n        position: static;\n    }\n\n    .detail-search .store-address {\n        padding: 15px 10px 25px;\n    }\n\n    .store-address {\n        padding: 10px 15px 15px;\n    }\n\n    .store-detail-info h2 {\n        display: block;\n        font-size: 20px;\n        border-bottom: 1px solid #eee;\n        margin-top: 5px;\n        padding-bottom: 10px;\n        font-weight: 700;\n    }\n\n    #content.detail-search .nearby-stores-content .store-info {\n        width: 50%;\n    }\n\n    body {\n        padding-top: 55px;\n    }\n\n    #advanced-search .dropdown {\n        margin: 0 0 15px;\n        width: 100%;\n        display: inline-block;\n    }\n\n    .advanced-search-main {\n        display: inline-block;\n    }\n\n    #tabsJustifiedContent .btn {\n    }\n\n    .col-lg-5.spacing-with-padding {\n        padding-bottom: 15px;\n    }\n\n    #search-nearby input.form-control {\n        width: 66%;\n    }\n\n    .detail-search .storelocator-search input {\n        width: 100%;\n    }\n\n    iframe {\n        height: 300px;\n    }\n\n    #mapOnSearch {\n        height: 300px;\n    }\n\n    .call-details a {\n        font-size: 13px;\n        padding: 0 10%;\n    }\n\n    .store-locator .custom-tab-box ul li a {\n        width: 15px;\n        height: 15px;\n    }\n\n    #tabsJustifiedContent .btn {\n        margin-top: 10px;\n    }\n\n    .nearby-stores-content ul {\n        display: block;\n    }\n\n    .nearby-stores-content ul li {\n        display: inline-block;\n        width: 47%;\n        margin-bottom: 20px;\n        margin-right: 20px;\n    }\n\n    .nearby-stores-content ul li:nth-child(even) {\n        margin-right: 0;\n    }\n\n    .nav-flex-icons {\n        padding-top: 8px;\n        float: right;\n    }\n\n    .map-view-stores ul li a.nav-link {\n        padding-left: 6px;\n        padding-right: 6px;\n    }\n\n    .map-view-stores h2 {\n        padding-right: 30px;\n    }\n\n    .container {\n        max-width: 100%;\n    }\n\n    .list-view-sidebar {\n        border-bottom: solid 1px #c4161c;\n    }\n\n    #content.detail-search .list-view-sidebar {\n        border-bottom: none;\n    }\n\n    #listingTable .flex-direction-nav a {\n        height: 30px;\n        width: 30px;\n    }\n}\n\n@media all and (max-width:479px) {\n    .new-popup-form .time-slot-field .slot-all {\n        padding-left: 5px;\n        text-align: -webkit-auto;\n    }\n\n    #corona-notif span.text-center {\n        font-size: 12px;\n    }\n\n    #corona-notif a {\n        margin: 0 10px;\n    }\n\n    div#slidernew {\n        margin: 0 0 18px;\n    }\n\n    #content.detail-search .nearby-stores-content .store-info {\n        width: 100%;\n    }\n\n    div#carouselnew {\n        border: none;\n    }\n\n    #listingTable .flex-direction-nav a:before {\n        font-size: 22px;\n    }\n\n    #listingTable .flex-direction-nav a {\n        height: 22px;\n        width: 22px;\n    }\n\n    #carouselnew .flex-direction-nav a {\n        top: 63%;\n    }\n\n    .map-view-stores {\n        display: block;\n    }\n\n    #header ul.navbar-nav li.toll_free_number_national {\n        float: left;\n    }\n\n    .sticky .nav-flex-icons {\n        display: none;\n    }\n\n    .map-view-stores ul li a.nav-link {\n        padding-left: 15px;\n        padding-right: 15px;\n    }\n\n    .call-details a {\n        font-size: 10px;\n        padding: 0 2%;\n        width: 49%;\n    }\n\n    a.browse-inventory.redefining-width.full-on-desktop.hideondesktop {\n        display: block;\n    }\n\n    a.browse-inventory.redefining-width.full-on-desktop {\n        width: 100%!important;\n    }\n\n    .nearby-stores-content ul li {\n        width: 46%;\n    }\n\n    .imgs-grid.imgs-grid-4 .imgs-grid-image,.imgs-grid.imgs-grid-6 .imgs-grid-image {\n        width: 100%;\n        padding-right: 0;\n    }\n\n    .view-map {\n        float: none;\n        text-align: center;\n    }\n\n    .map-view-stores .nav-tabs li {\n        margin-bottom: 0;\n        display: inline-block;\n        margin: 9px -3px 0 -4px;\n    }\n\n    .map-view-stores .nav-tabs {\n        text-align: center;\n        display: inline-block;\n    }\n\n    .map-view-stores h2 {\n        text-align: center;\n    }\n}\n\n@media all and (max-width:360px) {\n    .new-popup-form .row.select-slots span {\n        padding: 10px 13px;\n    }\n\n    .call-details a {\n        font-size: 9px;\n    }\n}\n\n@media all and (max-width:359px) {\n    .custom-tab-box .store-address address {\n        max-width: 60%;\n    }\n\n    .new-popup-form .day-block .slot-time {\n        width: 30px;\n        height: 30px;\n        font-size: 13px;\n    }\n\n    .new-popup-form .day-block .slot-date {\n        width: 30px;\n        font-size: 13px;\n    }\n\n    .new-popup-form .time-slot {\n        width: 23%;\n        font-size: 12px;\n    }\n\n    .new-popup-form .row.select-slots span {\n        padding: 10px 11px;\n        font-size: 12px;\n    }\n\n    #appointment.new-popup-form .input-block label {\n        font-size: 12px;\n    }\n\n    .call-details a {\n        font-size: 10px;\n    }\n}\n\nspan.glassname {\n    font-weight: 100;\n}\n\n.page-item.active .page-link {\n    background-color: #208178;\n    border-color: #208178;\n}\n\n.page-link {\n    color: #218178;\n}\n\n.page-link:hover {\n    color: #218178;\n}\n\n.site-map li.site-map-city a {\n    color: #4d4d4f;\n}\n\n.site-map li.site-map-state a {\n    color: #044963;\n}\n\n@media(max-width:767px) {\n    .search-box-inventroy.detailpage {\n        padding-left: 15px;\n        padding-right: 15px;\n    }\n\n    #tabsJustifiedContent .search-box-inventroy.detailpage .btn {\n        margin-top: 0;\n    }\n\n    #tabsJustifiedContent .search-box-inventroy.detailpage input {\n        height: 48px;\n    }\n}\n\n#flexbox {\n    display: flex;\n    flex-wrap: wrap;\n    width: 100%;\n    row-gap: 5px;\n    text-align: center;\n  }\n  \n  #flexbox > div {\n    border: 1px solid white;\n    background-color: #E5E5FF;\n    flex: 1 1 auto;\n    width: 220px;\n  }\n  .ant-tabs-nav-list {\n    display: flex;\n    align-items: center;\n    width:80%;\n  }\n  .ant-tabs-tab {\n    width: 50%;\n    justify-content: center;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
